import type { Dict } from "./types";

// Malayalam (മലയാളം) — flat dict covering every namespace/key from
// core.ts + owner.ts + tenant.ts's `en` blocks.
export const ml: Dict = {
  common: {
    save: "മാറ്റങ്ങൾ സേവ് ചെയ്യുക",
    saving: "സേവ് ചെയ്യുന്നു…",
    cancel: "റദ്ദാക്കുക",
    remove: "നീക്കം ചെയ്യുക",
    continue: "തുടരുക",
    somethingWrong: "എന്തോ പിശക് സംഭവിച്ചു",
    logOut: "ലോഗ് ഔട്ട്",
    welcomeBackGreet: "തിരികെ സ്വാഗതം,",
    hiGreet: "ഹായ്,",
    statusOpen: "ഓപ്പൺ",
    statusInProgress: "പുരോഗതിയിൽ",
    statusResolved: "പരിഹരിച്ചു",
  },
  requests: {
    categoryLabel: "വിഭാഗം (ഓപ്ഷണൽ)",
    categoryPlumbing: "പ്ലംബിംഗ്",
    categoryElectrical: "ഇലക്ട്രിക്കൽ",
    categoryAppliance: "ഉപകരണം",
    categoryFurniture: "ഫർണിച്ചർ",
    categoryCleaning: "ക്ലീനിംഗ്",
    categoryPestControl: "പെസ്റ്റ് കൺട്രോൾ",
    categoryOther: "മറ്റുള്ളവ",
    urgentCheckboxLabel: "ഇത് അടിയന്തിരമാണ്",
    urgentBadge: "അടിയന്തിരം",
    photoLabel: "ഫോട്ടോ ചേർക്കുക (ഓപ്ഷണൽ)",
    addPhotoBtn: "ഫോട്ടോ ചേർക്കുക",
    removePhotoAria: "ഫോട്ടോ നീക്കം ചെയ്യുക",
    updatesHeading: "അപ്‌ഡേറ്റുകൾ",
    noUpdatesYet: "ഇതുവരെ അപ്‌ഡേറ്റുകൾ ഒന്നുമില്ല.",
    addCommentPlaceholder: "ഒരു കുറിപ്പ് ചേർക്കുക…",
    postCommentBtn: "പോസ്റ്റ് ചെയ്യുക",
    postingCommentBtn: "പോസ്റ്റ് ചെയ്യുന്നു…",
    callBtn: "വിളിക്കുക",
    whatsappBtn: "വാട്ട്‌സ്ആപ്പ്",
  },
  nav: {
    home: "ഹോം",
    listings: "ലിസ്റ്റിംഗുകൾ",
    notebook: "നോട്ട്ബുക്ക്",
    requests: "റിക്വസ്റ്റുകൾ",
    settings: "സെറ്റിംഗ്സ്",
    browse: "പ്രോപ്പർട്ടികൾ ബ്രൗസ് ചെയ്യുക",
    payments: "പേയ്‌മെന്റുകൾ",
    ownerDashboard: "ഓണർ ഡാഷ്ബോർഡ്",
    tenantDashboard: "ടെനന്റ് ഡാഷ്ബോർഡ്",
  },
  auth: {
    welcomeEyebrow: "സ്വാഗതം",
    welcomeTitle: "ToLetBook-ലേക്ക് സ്വാഗതം",
    welcomeSub: "നിങ്ങളുടെ അക്കൗണ്ടിലേക്ക് ലോഗിൻ ചെയ്യുക, അല്ലെങ്കിൽ പുതിയത് ഉണ്ടാക്കുക.",
    logIn: "ലോഗിൻ ചെയ്യുക",
    createAccount: "അക്കൗണ്ട് ഉണ്ടാക്കുക",
    loginTitle: "തിരികെ സ്വാഗതം",
    loginSub: "നിങ്ങളുടെ ഡാഷ്‌ബോർഡിലേക്ക് പോകാൻ ലോഗിൻ ചെയ്യുക.",
    registerTitle: "നിങ്ങളുടെ അക്കൗണ്ട് സൃഷ്ടിക്കുക",
    registerSub: "ഒരു പ്രോപ്പർട്ടി ലിസ്റ്റ് ചെയ്യുക അല്ലെങ്കിൽ നിങ്ങളുടെ അടുത്ത വീട് കണ്ടെത്തുക — ബ്രോക്കർമാരില്ലാതെ, ബുദ്ധിമുട്ടില്ലാതെ.",
    passwordHint: "കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ.",
    referralCodeLabel: "റഫറൽ കോഡ് (ഓപ്ഷണൽ)",
    referralCodePlaceholder: "നിങ്ങളുടെ പക്കൽ കോഡ് ഉണ്ടെങ്കിൽ നൽകുക",
    agreeTermsText: "ToLetBook-ന്റെ നിബന്ധനകളും വ്യവസ്ഥകളും സ്വകാര്യതാ നയവും ഞാൻ അംഗീകരിക്കുന്നു",
    viewTermsLink: "നിബന്ധനകളും വ്യവസ്ഥകളും കാണുക",
    viewPrivacyLink: "സ്വകാര്യതാ നയം കാണുക",
    hideTermsLink: "നിബന്ധനകളും വ്യവസ്ഥകളും മറയ്ക്കുക",
    errMustAgreeTerms: "തുടരാൻ ദയവായി നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കുക",
    loginBusy: "ലോഗിൻ ചെയ്യുന്നു…",
    emailLabel: "ഇമെയിൽ",
    emailPlaceholder: "you@example.com",
    passwordLabel: "പാസ്‌വേഡ്",
    passwordPlaceholder: "നിങ്ങളുടെ പാസ്‌വേഡ്",
    errEmailPassword: "നിങ്ങളുടെ ഇമെയിലും പാസ്‌വേഡും നൽകുക",
    getStartedEyebrow: "തുടങ്ങാം",
    roleTitle: "നിങ്ങൾ ആരാണെന്ന് പറയൂ",
    roleSub: "അതിലൂടെ ഞങ്ങൾക്ക് നിങ്ങൾക്ക് ശരിയായ ഡാഷ്ബോർഡ് സെറ്റപ്പ് ചെയ്യാം.",
    roleOwnerTitle: "ഞാൻ ഒരു പ്രോപ്പർട്ടി / പിജി ഉടമയാണ്",
    roleOwnerSub: "പ്രോപ്പർട്ടികൾ ലിസ്റ്റ് ചെയ്യുക, ടെനന്റുകളെ മാനേജ് ചെയ്യുക, വാടക ട്രാക്ക് ചെയ്യുക",
    roleTenantTitle: "ഞാൻ ഒരു ടെനന്റ് ആണ്",
    roleTenantSub: "ലിസ്റ്റിംഗുകൾ ബ്രൗസ് ചെയ്യുക, വാടക അടയ്ക്കുക, റിക്വസ്റ്റുകൾ അയയ്ക്കുക",
    step1Eyebrow: "സ്റ്റെപ്പ് 1",
    credentialsTitle: "നിങ്ങളുടെ ലോഗിൻ ഉണ്ടാക്കുക",
    newPasswordPlaceholder: "കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ",
    phoneOptionalLabel: "മൊബൈൽ നമ്പർ (ഓപ്ഷണൽ)",
    phonePlaceholder: "10 അക്ക മൊബൈൽ നമ്പർ",
    errValidEmail: "ശരിയായ ഇമെയിൽ വിലാസം നൽകുക",
    errPasswordLength: "പാസ്‌വേഡിന് കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ വേണം",
    errValidPhoneOptional: "ശരിയായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക, അല്ലെങ്കിൽ ഒഴിച്ചിടുക",
    step2Eyebrow: "സ്റ്റെപ്പ് 2",
    profileTitle: "നിങ്ങളെക്കുറിച്ച് അല്പം",
    fullNameLabel: "മുഴുവൻ പേര്",
    fullNamePlaceholder: "നിങ്ങളുടെ മുഴുവൻ പേര്",
    profileBusy: "ദയവായി കാത്തിരിക്കുക…",
    errName: "നിങ്ങളുടെ പേര് നൽകുക",
    step3Eyebrow: "സ്റ്റെപ്പ് 3",
    propertyTypeTitle: "നിങ്ങൾ എന്താണ് മാനേജ് ചെയ്യുന്നത്?",
    propertyTypeSub: "ഇത് നിങ്ങൾക്ക് ഏത് ഡാഷ്ബോർഡ് കാഴ്ചകൾ കാണാം എന്ന് തീരുമാനിക്കും — ഇത് പിന്നീട് മാറ്റാം.",
    typeIndependentTitle: "ഇൻഡിപെൻഡന്റ് പ്രോപ്പർട്ടികൾ",
    typeIndependentSub: "മുഴുവൻ വീടുകൾ, ഫ്ലാറ്റുകൾ, വില്ലകൾ",
    typePgTitle: "പിജി / ഹോസ്റ്റൽ",
    typePgSub: "ബെഡ് അനുസരിച്ച് ബിൽ ചെയ്യുന്ന ഷെയേർഡ് മുറികൾ",
    typeBothTitle: "രണ്ടും",
    typeBothSub: "ഇൻഡിപെൻഡന്റ് യൂണിറ്റുകളും പിജി മുറികളും ചേർന്നത്",
    almostDoneEyebrow: "ഏകദേശം കഴിഞ്ഞു",
    cityTitle: "നിങ്ങൾ എവിടെയാണ് പ്രവർത്തിക്കുന്നത്?",
    citySub: "ഇത് ഉപയോഗിച്ച് നിങ്ങളുടെ ലിസ്റ്റിംഗുകൾ അടുത്തുള്ള വാടകക്കാർക്ക് ആദ്യം കാണിക്കും.",
    cityLabel: "നഗരം",
    cityPlaceholder: "ഉദാ. മുംബൈ",
    bankDetailsTitle: "ഞങ്ങൾ നിങ്ങൾക്ക് എങ്ങനെ പണം നൽകണം?",
    bankDetailsSub: "വാടകയും ഡെപ്പോസിറ്റും നേരിട്ട് നിങ്ങൾക്ക് അയക്കാൻ നിങ്ങളുടെ ബാങ്ക് അക്കൗണ്ട് ചേർക്കുക.",
    payoutMethodUpi: "UPI ഐഡി",
    payoutMethodBank: "ബാങ്ക് അക്കൗണ്ട്",
    upiIdLabel: "UPI ഐഡി",
    upiIdPlaceholder: "ഉദാ. name@okhdfcbank",
    errValidUpi: "ശരിയായ UPI ഐഡി നൽകുക",
    bankAccountHolderLabel: "അക്കൗണ്ട് ഉടമയുടെ പേര്",
    bankAccountHolderPlaceholder: "ബാങ്ക് രേഖകൾ പ്രകാരം",
    bankAccountNumberLabel: "അക്കൗണ്ട് നമ്പർ",
    bankAccountNumberPlaceholder: "ബാങ്ക് അക്കൗണ്ട് നമ്പർ",
    bankIfscLabel: "IFSC കോഡ്",
    bankIfscPlaceholder: "ഉദാ. HDFC0001234",
    bankDetailsHint: "നിങ്ങൾക്ക് ഇത് എപ്പോൾ വേണമെങ്കിലും സെറ്റിംഗ്സിൽ നിന്ന് ചേർക്കാനോ മാറ്റാനോ കഴിയും.",
    skipForNowLink: "ഇപ്പോൾ വേണ്ട",
    errValidIfsc: "ശരിയായ IFSC കോഡ് നൽകുക",
    finishBusy: "സെറ്റപ്പ് ചെയ്യുന്നു…",
    finish: "പൂർത്തിയാക്കുക",
    doneTitle: "നിങ്ങൾ റെഡിയാണ്!",
    doneSub: "നിങ്ങളുടെ ഡാഷ്ബോർഡ് തയ്യാറാണ്.",
    goToDashboard: "ഡാഷ്ബോർഡിലേക്ക് പോകുക",
    welcomeBackToast: "തിരികെ സ്വാഗതം, {name}!",
    welcomeNewToast: "ToLetBook-ലേക്ക് സ്വാഗതം, {name}!",
    orDivider: "അല്ലെങ്കിൽ",
    googleNoAccountToast: "ആ Google ഇമെയിലിന് ToLetBook അക്കൗണ്ട് കണ്ടെത്തിയില്ല — നിങ്ങളെ സെറ്റപ്പ് ചെയ്യാം.",
    forgotPasswordLink: "പാസ്‌വേഡ് മറന്നോ?",
    forgotPasswordEyebrow: "പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യുക",
    forgotPasswordTitle: "പാസ്‌വേഡ് മറന്നോ?",
    forgotPasswordSub: "നിങ്ങളുടെ ഇമെയിൽ നൽകുക, അത് റീസെറ്റ് ചെയ്യാൻ ഞങ്ങൾ നിങ്ങൾക്ക് ഒരു ലിങ്ക് അയക്കും.",
    forgotPasswordSubmit: "റീസെറ്റ് ലിങ്ക് അയയ്ക്കുക",
    forgotPasswordBusy: "അയയ്ക്കുന്നു…",
    forgotPasswordSentTitle: "നിങ്ങളുടെ ഇമെയിൽ പരിശോധിക്കുക",
    forgotPasswordSentSub: "ആ ഇമെയിലിന് അക്കൗണ്ട് ഉണ്ടെങ്കിൽ, നിങ്ങളുടെ പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യാൻ ഞങ്ങൾ ഒരു ലിങ്ക് അയച്ചിട്ടുണ്ട്.",
    resetPasswordEyebrow: "പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യുക",
    resetPasswordTitle: "പുതിയ പാസ്‌വേഡ് തിരഞ്ഞെടുക്കുക",
    resetPasswordSub: "ഈ ലിങ്ക് 1 മണിക്കൂർ സാധുവാണ്.",
    newPasswordLabel: "പുതിയ പാസ്‌വേഡ്",
    confirmPasswordLabel: "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
    errPasswordMismatch: "പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നില്ല",
    resetPasswordSubmit: "പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യുക",
    resetPasswordBusy: "റീസെറ്റ് ചെയ്യുന്നു…",
    resetPasswordDoneTitle: "പാസ്‌വേഡ് റീസെറ്റ് ചെയ്തു",
    resetPasswordDoneSub: "ഇനി നിങ്ങൾക്ക് പുതിയ പാസ്‌വേഡ് ഉപയോഗിച്ച് ലോഗിൻ ചെയ്യാം.",
  },
  settings: {
    title: "സെറ്റിംഗ്സ്",
    profileMenu: "പ്രൊഫൈൽ",
    reportsMenu: "റിപ്പോർട്ടുകൾ",
    plansMenu: "പ്ലാനുകളും ബില്ലിംഗും",
    referMenu: "റഫർ ചെയ്ത് സമ്പാദിക്കുക",
    appearance: "തീം",
    language: "ഭാഷ",
    dark: "ഡാർക്ക്",
    light: "ലൈറ്റ്",
    termsTitle: "നിബന്ധനകളും വ്യവസ്ഥകളും",
    privacyTitle: "സ്വകാര്യതാ നയം",
    bankDetailsMenu: "എന്റെ ബാങ്ക് വിവരങ്ങൾ",
    bankDetailsHint: "വാടകയും ഡെപ്പോസിറ്റും നേരിട്ട് നിങ്ങൾക്ക് അയക്കാൻ ഈ വിവരങ്ങൾ ഉപയോഗിക്കുന്നു. ഇവ വാടകക്കാർക്ക് ഒരിക്കലും കാണിക്കില്ല.",
    bankDetailsSaved: "ബാങ്ക് വിവരങ്ങൾ സേവ് ചെയ്തു",
    contactUsMenu: "ഞങ്ങളെ ബന്ധപ്പെടുക",
    emailUsedToLogIn: "ഇമെയിൽ (ലോഗിൻ ചെയ്യാൻ ഉപയോഗിക്കുന്നത്)",
    name: "പേര്",
    phone: "ഫോൺ നമ്പർ",
    phonePlaceholder: "10 അക്ക മൊബൈൽ നമ്പർ",
    city: "നഗരം",
    profileUpdated: "പ്രൊഫൈൽ അപ്ഡേറ്റ് ചെയ്തു",
    demoNotice: "ഇവിടെയുള്ള അക്കൗണ്ടുകൾ ഡെമോ ആവശ്യത്തിന് മാത്രമാണ്; ഏതെങ്കിലും ഇമെയിലും പാസ്‌വേഡും ഉപയോഗിക്കുക.",
    verificationTitle: "ഐഡന്റിറ്റി വെരിഫിക്കേഷൻ",
    verificationHint: "നിങ്ങളുടെ പ്രൊഫൈലിലും ലിസ്റ്റിംഗുകളിലും വെരിഫൈഡ് ബാഡ്ജ് ലഭിക്കാൻ സർക്കാർ ID (മുൻവശവും പിൻവശവും) അപ്‌ലോഡ് ചെയ്യുക.",
    verificationSubmit: "വെരിഫിക്കേഷന് സമർപ്പിക്കുക",
    verificationSubmitted: "വെരിഫിക്കേഷന് സമർപ്പിച്ചു",
    errIdPhotosRequired: "നിങ്ങളുടെ ID യുടെ മുൻവശവും പിൻവശവും രണ്ടും ചേർക്കുക",
    verificationVerified: "നിങ്ങൾ വെരിഫൈഡ് ആണ്",
    verificationPending: "വെരിഫിക്കേഷൻ തീർപ്പുകൽപ്പിക്കാതെ ഇരിക്കുന്നു",
    verificationPendingSub: "അവലോകനം കഴിഞ്ഞാലുടൻ ഞങ്ങൾ നിങ്ങളെ അറിയിക്കും — സാധാരണയായി ഒന്നോ രണ്ടോ ദിവസത്തിനുള്ളിൽ.",
    verificationRejected: "വെരിഫിക്കേഷൻ അംഗീകരിച്ചില്ല",
    changePasswordTitle: "പാസ്‌വേഡ് മാറ്റുക",
    currentPasswordLabel: "നിലവിലെ പാസ്‌വേഡ്",
    errCurrentPasswordRequired: "നിങ്ങളുടെ നിലവിലെ പാസ്‌വേഡ് നൽകുക",
    passwordChanged: "പാസ്‌വേഡ് മാറ്റി",
    changePasswordButton: "പാസ്‌വേഡ് അപ്ഡേറ്റ് ചെയ്യുക",
  },
  notifications: {
    title: "അറിയിപ്പുകൾ",
    enabledToast: "അറിയിപ്പുകൾ ഓണാക്കി",
    disabledToast: "അറിയിപ്പുകൾ ഓഫാക്കി",
    couldNotEnableToast: "അറിയിപ്പുകൾ ഓണാക്കാൻ കഴിഞ്ഞില്ല",
    notConfigured: "ഈ സെർവറിൽ അറിയിപ്പുകൾ ഇതുവരെ സെറ്റപ്പ് ചെയ്തിട്ടില്ല",
    deniedHint: "നിങ്ങളുടെ ഡിവൈസ് സെറ്റിംഗ്സിൽ ഈ ആപ്പിനുള്ള അറിയിപ്പുകൾ ബ്ലോക്ക് ചെയ്തിരിക്കുന്നു.",
    markAllRead: "എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക",
    emptyState: "ഇതുവരെ അറിയിപ്പുകൾ ഒന്നുമില്ല.",
  },
  refer: {
    title: "റഫർ ചെയ്ത് സമ്പാദിക്കുക",
    heroTitle: "1 മാസം കൊടുക്കൂ, 1 മാസം നേടൂ",
    heroSub: "നിങ്ങളുടെ സുഹൃത്തിനെ ToLetBook-ലേക്ക് ക്ഷണിക്കൂ. അവർ ആപ്പ് ഡൗൺലോഡ് ചെയ്ത് തുടങ്ങിയാൽ — ഓണറായി അവരുടെ ആദ്യ പ്രോപ്പർട്ടി ലിസ്റ്റ് ചെയ്താലും, ടെനന്റായി അവരുടെ ആദ്യ കോൺടാക്റ്റ് അൺലോക്ക് ചെയ്താലും — നിങ്ങൾ ഇരുവർക്കും 1 മാസത്തെ Pro സൗജന്യമായി ലഭിക്കും.",
    yourCodeLabel: "നിങ്ങളുടെ റഫറൽ കോഡ്",
    shareButton: "ക്ഷണം പങ്കിടുക",
    copiedToast: "റഫറൽ ലിങ്ക് കോപ്പി ചെയ്തു",
    statsReferred: "{count} പേരെ ക്ഷണിച്ചു",
    statsRewarded: "{count} പേർക്ക് റിവാർഡ് ലഭിച്ചു",
    statsRemaining: "{count} സൗജന്യ മാസങ്ങൾ ബാക്കി",
    howItWorksTitle: "ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു",
    step1: "നിങ്ങളുടെ കോഡ് അല്ലെങ്കിൽ ലിങ്ക് ഒരു സുഹൃത്തുമായി പങ്കിടുക",
    step2: "അവർ ToLetBook ഡൗൺലോഡ് ചെയ്ത് സൈൻ അപ്പ് ചെയ്യുന്നു",
    step3: "അവർ ഓണറായി ആദ്യ പ്രോപ്പർട്ടി ലിസ്റ്റ് ചെയ്യുന്നു, അല്ലെങ്കിൽ ടെനന്റായി ആദ്യ കോൺടാക്റ്റ് അൺലോക്ക് ചെയ്യുന്നു — നിങ്ങൾ ഇരുവർക്കും 1 മാസത്തെ Pro സൗജന്യമായി ലഭിക്കും",
    historyTitle: "നിങ്ങളുടെ റഫറലുകൾ",
    emptyState: "ഇതുവരെ റഫറലുകൾ ഒന്നുമില്ല — തുടങ്ങാൻ നിങ്ങളുടെ കോഡ് പങ്കിടുക",
    statusPending: "അവരുടെ ആദ്യ ലിസ്റ്റിംഗിനായി കാത്തിരിക്കുന്നു",
    statusRewarded: "റിവാർഡ് ലഭിച്ചു — 1 മാസം സൗജന്യം",
    statusCapped: "അവർക്ക് റിവാർഡ് ലഭിച്ചു — നിങ്ങളുടെ പരിധി തീർന്നു",
    shareMessage: "എന്നോടൊപ്പം ToLetBook-ൽ ചേരൂ! സൈൻ അപ്പ് ചെയ്യുമ്പോൾ എന്റെ റഫറൽ കോഡ് {code} ഉപയോഗിക്കൂ — നമുക്ക് ഇരുവർക്കും 1 മാസത്തെ Pro സൗജന്യമായി ലഭിക്കും.",
  },
  ownerTerms: {
    intro: "ToLetBook ഉപയോഗിക്കുന്നതിലൂടെ നിങ്ങൾ ഈ നിബന്ധനകൾ അംഗീകരിക്കുന്നു.",
    bullet1: "ToLetBook വഴി നടത്തുന്ന വാടകയും ഡെപ്പോസിറ്റ് പേയ്‌മെന്റുകളും Razorpay വഴി പ്രോസസ്സ് ചെയ്യുന്നു. ToLetBook ഒരു ബാങ്ക് അല്ല, Razorpay സ്ഥിരീകരിക്കുന്നതിനപ്പുറം ഒരു ഫലവും ഉറപ്പുനൽകുന്നില്ല.",
    bullet2: "നിങ്ങൾ നൽകുന്ന പ്രോപ്പർട്ടി, ടെനന്റ്, പേയ്‌മെന്റ് വിവരങ്ങൾ ശരിയായിരിക്കുന്നതിനുള്ള ഉത്തരവാദിത്തം നിങ്ങളുടേതാണ്.",
    bullet3: "നിങ്ങൾ നൽകുന്ന പ്രോപ്പർട്ടി, ടെനന്റ്, പേയ്‌മെന്റ് വിവരങ്ങൾ ഈ ഡെമോയ്ക്ക് വേണ്ടി മാത്രം സൂക്ഷിക്കുന്നു, മൂന്നാം കക്ഷികളുമായി പങ്കിടുന്നില്ല.",
    bullet4: "റിപ്പോർട്ടുകളിലും നോട്ട്ബുക്കിലുമുള്ള കണക്കുകൾ നിങ്ങൾ നൽകുന്ന ഡാറ്റയിൽ നിന്ന് നേരിട്ട് കണക്കാക്കുന്നു — ഓഡിറ്റ് ചെയ്തതോ പരിശോധിച്ചതോ അല്ല.",
    bullet5: "മാപ്പ്, ലൊക്കേഷൻ ഫീച്ചറുകൾ Google Maps ആണ് നൽകുന്നത്, ഇത് Google-ന്റെ സ്വന്തം നിബന്ധനകൾക്ക് വിധേയമാണ്.",
  },
  tenantTerms: {
    intro: "ToLetBook ഉപയോഗിക്കുന്നതിലൂടെ നിങ്ങൾ ഈ നിബന്ധനകൾ അംഗീകരിക്കുന്നു.",
    bullet1: "ToLetBook വഴി നടത്തുന്ന വാടകയും ഡെപ്പോസിറ്റ് പേയ്‌മെന്റുകളും Razorpay വഴി പ്രോസസ്സ് ചെയ്യുന്നു. ToLetBook ഒരു ബാങ്ക് അല്ല, Razorpay സ്ഥിരീകരിക്കുന്നതിനപ്പുറം ഒരു ഫലവും ഉറപ്പുനൽകുന്നില്ല.",
    bullet2: "നിങ്ങൾ നൽകുന്ന വിവരങ്ങൾ ശരിയായിരിക്കുന്നതിനുള്ള ഉത്തരവാദിത്തം നിങ്ങളുടേതാണ്.",
    bullet3: "നിങ്ങൾ നൽകുന്ന പ്രോപ്പർട്ടി, ടെനന്റ്, പേയ്‌മെന്റ് വിവരങ്ങൾ ഈ ഡെമോയ്ക്ക് വേണ്ടി മാത്രം സൂക്ഷിക്കുന്നു, മൂന്നാം കക്ഷികളുമായി പങ്കിടുന്നില്ല.",
    bullet4: "കാണിച്ചിരിക്കുന്ന കണക്കുകൾ നിങ്ങളോ നിങ്ങളുടെ ഓണറോ നൽകുന്ന ഡാറ്റയിൽ നിന്ന് നേരിട്ട് കണക്കാക്കുന്നു — ഓഡിറ്റ് ചെയ്തതോ പരിശോധിച്ചതോ അല്ല.",
    bullet5: "മാപ്പ്, ലൊക്കേഷൻ ഫീച്ചറുകൾ Google Maps ആണ് നൽകുന്നത്, ഇത് Google-ന്റെ സ്വന്തം നിബന്ധനകൾക്ക് വിധേയമാണ്.",
  },
  ownerHome: {
    sectionTitlePg: "നിങ്ങളുടെ പിജികൾ",
    sectionTitleProperties: "നിങ്ങളുടെ പ്രോപ്പർട്ടികൾ",
    thisMonth: "ഈ മാസം",
    pctCollected: "{pct}% പിരിച്ചെടുത്തു",
    received: "കിട്ടി",
    pending: "ബാക്കിയുണ്ട്",
    remindAll: "എല്ലാവരെയും ഓർമ്മിപ്പിക്കുക",
    remindersSent: "{count} വാടകക്കാർക്ക് റിമൈൻഡർ അയച്ചു",
    couldNotSendReminders: "റിമൈൻഡറുകൾ അയക്കാൻ കഴിഞ്ഞില്ല",
    bedOccupancy: "ബെഡ് ഒക്യുപൻസി",
    bedsFraction: "{filled}/{total} ബെഡുകൾ",
    acrossPg: "ആകെ {count} പിജി {unit}",
    pgUnitSingular: "പ്രോപ്പർട്ടി",
    pgUnitPlural: "പ്രോപ്പർട്ടികൾ",
    totalCount: "ആകെ {count}",
    addPropertyAria: "പ്രോപ്പർട്ടി ചേർക്കുക",
    addUnitFab: "യൂണിറ്റ് ചേർക്കുക",
    sendWhatsappReceiptBtn: "WhatsApp രസീത് അയയ്ക്കുക",
    directUpiPayLinkBtn: "ഡയറക്ട് UPI പേ ലിങ്ക്",
    whatsappReceiptMessage: "ഹായ് {tenant}, {property}-നുള്ള നിങ്ങളുടെ വാടക രസീത്: {amount} ({status}). - {owner}, ToLetBook വഴി",
    upiPayLinkMessage: "ഹായ് {tenant}, ദയവായി {property}-ന്റെ ഈ മാസത്തെ വാടക ({amount}) UPI വഴി അടയ്ക്കുക: {link} - {owner}, ToLetBook വഴി",
    noTenantPhone: "ഈ വാടകക്കാരന്റെ ഫോൺ നമ്പർ രേഖപ്പെടുത്തിയിട്ടില്ല",
    noUpiIdSet: "ആദ്യം സെറ്റിംഗ്സിൽ നിങ്ങളുടെ UPI ID ചേർക്കുക",
    tabProperty: "പ്രോപ്പർട്ടി",
    tabPg: "പിജി",
    emptyNoProperties: "ഇതുവരെ പ്രോപ്പർട്ടികൾ ഇല്ല. ആദ്യത്തേത് ചേർക്കാൻ + ടാപ്പ് ചെയ്യുക.",
    emptyNoIndependent: "ഇതുവരെ ഇൻഡിപെൻഡന്റ് പ്രോപ്പർട്ടികൾ ഇല്ല.",
    emptyNoPg: "ഇതുവരെ പിജി പ്രോപ്പർട്ടികൾ ഇല്ല.",
    emptyNoCommercial: "ഇതുവരെ കൊമേഴ്‌സ്യൽ പ്രോപ്പർട്ടികൾ ഇല്ല.",
    filterAll: "എല്ലാം",
    filterResidential: "റെസിഡൻഷ്യൽ",
    filterCommercial: "കൊമേഴ്‌സ്യൽ",
    filterPg: "PG / ഹോസ്റ്റൽ",
    sqftSuffix: "ചതുരശ്ര അടി",
    listedOnMarketplace: "മാർക്കറ്റ്‌പ്ലേസിൽ ലിസ്റ്റ് ചെയ്തു",
    removedFromMarketplace: "മാർക്കറ്റ്‌പ്ലേസിൽ നിന്ന് നീക്കി",
    couldNotUpdateListing: "ലിസ്റ്റിംഗ് അപ്ഡേറ്റ് ചെയ്യാനായില്ല",
    rentUpdated: "വാടക അപ്ഡേറ്റ് ചെയ്തു",
    couldNotUpdateRent: "വാടക അപ്ഡേറ്റ് ചെയ്യാനായില്ല",
    maintenanceUpdated: "മെയിന്റനൻസ് അപ്ഡേറ്റ് ചെയ്തു",
    couldNotUpdateMaintenance: "മെയിന്റനൻസ് അപ്ഡേറ്റ് ചെയ്യാനായില്ല",
    paid: "അടച്ചു",
    tenantLabel: "ടെനന്റ്",
    perMonth: "/മാസം",
    phoneLabel: "ഫോൺ",
    noPhoneOnFile: "ഫോൺ നമ്പർ രേഖപ്പെടുത്തിയിട്ടില്ല",
    aadhaarLabel: "ആധാർ",
    depositLabel: "ഡെപ്പോസിറ്റ്",
    moveInDateLabel: "മൂവ്-ഇൻ തീയതി",
    hideManageOptions: "മാനേജ് ഓപ്ഷനുകൾ ഒളിപ്പിക്കുക",
    manage: "മാനേജ് ചെയ്യുക",
    manageHouses: "വീടുകൾ മാനേജ് ചെയ്യുക",
    rentalAgreement: "റെന്റൽ എഗ്രിമെന്റ്",
    rentalReceipts: "റെന്റൽ രസീതുകൾ",
    modifyRent: "വാടക മാറ്റുക",
    maintenanceMenu: "മെയിന്റനൻസ്",
    removeTenant: "ടെനന്റിനെ നീക്കുക",
    newRentLabel: "പുതിയ വാടക / മാസം",
    save: "സേവ് ചെയ്യുക",
    maintenancePerMonthLabel: "മെയിന്റനൻസ് / മാസം",
    vacantBadge: "ഒഴിവുണ്ട്",
    expectedRentLabel: "പ്രതീക്ഷിക്കുന്ന വാടക",
    depositSuffix: " · ഡെപ്പോസിറ്റ് {amount}",
    maintenanceLine: "+ {amount}/മാസം മെയിന്റനൻസ്",
    listOnToLet: "TO-LET മാർക്കറ്റ്‌പ്ലേസിൽ ലിസ്റ്റ് ചെയ്യുക",
    liveVisible: "ലൈവ് · വാടകക്കാർക്ക് കാണാം",
    notListedYet: "ഇതുവരെ ലിസ്റ്റ് ചെയ്തിട്ടില്ല",
    toggleToLetAria: "TO-LET ടോഗിൾ ചെയ്യുക",
    addTenantButton: "ടെനന്റിനെ ചേർക്കുക",
    occBoys: "ബോയ്സ് പിജി",
    occGirls: "ഗേൾസ് പിജി",
    occCoEd: "കോ-എഡ് പിജി",
    occDefault: "പിജി",
    listVacantBedsToLet: "ഒഴിവുള്ള ബെഡുകൾ TO-LET-ൽ ലിസ്റ്റ് ചെയ്യുക",
    fullyOccupied: "പൂർണ്ണമായി നിറഞ്ഞു · ഒഴിവുള്ള ബെഡുകൾ ഇല്ല",
  },
  ownerListings: {
    propertyAdded: "പ്രോപ്പർട്ടി ചേർത്തു",
    upgradeToastMsg: "നിങ്ങളുടെ പ്ലാനിന്റെ ലിസ്റ്റിംഗ് പരിധിയിൽ എത്തി — അപ്‌ഗ്രേഡ് ഓപ്ഷനുകളിലേക്ക് റീഡയറക്ട് ചെയ്യുന്നു.",
    heading: "എന്റെ പ്രോപ്പർട്ടികൾ",
    addLink: "+ ചേർക്കുക ›",
    emptyState: "ഇതുവരെ പ്രോപ്പർട്ടികൾ ഇല്ല — ആദ്യത്തേത് ചേർക്കുക.",
    confirmDelete: '"{label}" ഡിലീറ്റ് ചെയ്യണോ? ഇത് തിരികെ എടുക്കാൻ കഴിയില്ല.',
    propertyDeleted: "പ്രോപ്പർട്ടി ഡിലീറ്റ് ചെയ്തു",
    confirmDeleteHouse: '"{label}" നീക്കം ചെയ്യണോ? ഇത് തിരികെ കൊണ്ടുവരാൻ കഴിയില്ല.',
    houseRemoved: "വീട് നീക്കം ചെയ്തു",
    houseUpdated: "വീടിന്റെ വിവരങ്ങൾ അപ്‌ഡേറ്റ് ചെയ്തു",
    listedOnMarketplace: "മാർക്കറ്റ്‌പ്ലേസിൽ ലിസ്റ്റ് ചെയ്തു",
    removedFromMarketplace: "മാർക്കറ്റ്‌പ്ലേസിൽ നിന്ന് നീക്കി",
    couldNotUpdateListing: "ലിസ്റ്റിംഗ് അപ്ഡേറ്റ് ചെയ്യാനായില്ല",
    vacantBedsFraction: "{vacant} / {total} ഒഴിവുണ്ട്",
    listOnToLet: "TO-LET മാർക്കറ്റ്‌പ്ലേസിൽ ലിസ്റ്റ് ചെയ്യുക",
    listVacantBedsToLet: "ഒഴിവുള്ള ബെഡുകൾ TO-LET-ൽ ലിസ്റ്റ് ചെയ്യുക",
    liveVisible: "ലൈവ് · വാടകക്കാർക്ക് കാണാം",
    notListedYet: "ഇതുവരെ ലിസ്റ്റ് ചെയ്തിട്ടില്ല",
    toggleToLetAria: "TO-LET ടോഗിൾ ചെയ്യുക",
    moreOptionsAria: "കൂടുതൽ ഓപ്ഷനുകൾ",
    editDetails: "വിവരങ്ങൾ എഡിറ്റ് ചെയ്യുക",
    deleteProperty: "പ്രോപ്പർട്ടി ഡിലീറ്റ് ചെയ്യുക",
    expectedRentLabel: "പ്രതീക്ഷിക്കുന്ന വാടക",
    depositLabel: "ഡെപ്പോസിറ്റ്",
    noPhoneOnFile: "ഫോൺ നമ്പർ രേഖപ്പെടുത്തിയിട്ടില്ല",
    perMonth: "/മാസം",
    endTenancyButton: "ടെനൻസി അവസാനിപ്പിക്കുക",
    editTenantButton: "ടെനന്റിനെ മോഡിഫൈ ചെയ്യുക",
    saveTenantButton: "മാറ്റങ്ങൾ സേവ് ചെയ്യുക",
    tenantAdded: "ടെനന്റിനെ ചേർത്തു",
    tenantUpdated: "ടെനന്റിന്റെ വിവരങ്ങൾ അപ്‌ഡേറ്റ് ചെയ്തു",
    roomAdded: "മുറി ചേർത്തു",
    couldNotAddRoom: "മുറി ചേർക്കാനായില്ല",
    addTenantLink: "+ ടെനന്റിനെ ചേർക്കുക",
    installAppPromptTitle: "{name} ഇതുവരെ ToLetBook ഇൻസ്റ്റാൾ ചെയ്തിട്ടില്ല",
    installAppPromptBody: "അവർക്ക് അവരുടെ എഗ്രിമെന്റ് കാണാനും മൂവ്-ഇൻ വിവരങ്ങൾ പൂർത്തിയാക്കാനും ആപ്പ് ഷെയർ ചെയ്യുക.",
    notifyTenantPromptTitle: "WhatsApp-ൽ {name}-യെ അറിയിക്കുക",
    notifyTenantPromptBody: "അവർക്ക് ആപ്പ് തുറന്ന് മൂവ്-ഇൻ വിവരങ്ങൾ പൂർത്തിയാക്കാൻ ഇത് ഷെയർ ചെയ്യുക.",
    shareOnWhatsappBtn: "💬 WhatsApp-ൽ ഷെയർ ചെയ്യുക",
    installAppWhatsappMessage: "നമസ്കാരം, ഞാൻ ToLetBook-ൽ നിന്നുള്ള {owner} ആണ്. ഞാൻ നിങ്ങളെ \"{property}\" എന്നതിനായി ടെനന്റ് ആയി ചേർത്തിട്ടുണ്ട്. ദയവായി നിങ്ങളുടെ വാടക, എഗ്രിമെന്റ് കാണാനും മൂവ്-ഇൻ വിവരങ്ങൾ പൂർത്തിയാക്കാനും ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യുക: {link}",
    notifyTenantWhatsappMessage: "നമസ്കാരം, ഞാൻ ToLetBook-ൽ നിന്നുള്ള {owner} ആണ്. ഞാൻ നിങ്ങളെ \"{property}\" എന്നതിനായി ടെനന്റ് ആയി ചേർത്തിട്ടുണ്ട്. ദയവായി നിങ്ങളുടെ വാടക, എഗ്രിമെന്റ് കാണാനും മൂവ്-ഇൻ വിവരങ്ങൾ പൂർത്തിയാക്കാനും ആപ്പ് തുറക്കുക: {link}",
    editButton: "എഡിറ്റ് ചെയ്യുക",
    deleteButton: "ഡിലീറ്റ് ചെയ്യുക",
    perBed: "{amount}/ബെഡ്",
    priceTiers: "{count} പ്രൈസ് ടയറുകൾ",
    occupiedFraction: "{occupied}/{total} നിറഞ്ഞു",
    occupiedBadge: "നിറഞ്ഞു",
    vacantBadge: "ഒഴിവുണ്ട്",
    rentalAgreementButton: "റെന്റൽ എഗ്രിമെന്റ്",
    rentalReceiptsButton: "വാടക രസീതുകൾ",
    noReceiptsYet: "ഇതുവരെ അടച്ച രസീതുകൾ ഇല്ല.",
    receiptsBackLink: "‹ തിരികെ",
    loadingReceipts: "ലോഡ് ചെയ്യുന്നു…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "ഈ ഡിവൈസ്/ബ്രൗസറിൽ കോൺടാക്റ്റ് പിക്കർ സപ്പോർട്ട് ചെയ്യുന്നില്ല",
    errNameRequired: "ടെനന്റിന്റെ പേര് നിർബന്ധമാണ്",
    newTenant: "പുതിയ ടെനന്റ്",
    existingTenant: "നിലവിലുള്ള ടെനന്റ്",
    addFromContacts: "കോൺടാക്റ്റുകളിൽ നിന്ന് ചേർക്കുക",
    emptyExistingTenants: "നിങ്ങളുടെ പ്രോപ്പർട്ടികളിൽ ഇതുവരെ വേറെ ടെനന്റുകൾ ഇല്ല.",
    noPhoneOnFile: "ഫോൺ നമ്പർ രേഖപ്പെടുത്തിയിട്ടില്ല",
    tenantNameLabel: "ടെനന്റിന്റെ പേര്",
    phoneLabel: "ഫോൺ (രജിസ്റ്റർ ചെയ്തിട്ടുണ്ടെങ്കിൽ അവരുടെ ToLetBook അക്കൗണ്ടുമായി പൊരുത്തപ്പെടും)",
    phonePlaceholder: "10 അക്ക നമ്പർ",
    aadhaarLabel: "ആധാർ (ഓപ്ഷണൽ)",
    aadhaarPhotosLabel: "ആധാർ ഫോട്ടോകൾ (ഓപ്ഷണൽ)",
    aadhaarFront: "മുൻവശം",
    aadhaarBack: "പിൻവശം",
    removeAadhaarPhotoAria: "ഫോട്ടോ നീക്കം ചെയ്യുക",
    rentLabel: "വാടക / മാസം",
    depositLabel: "ഡെപ്പോസിറ്റ്",
    dateOfOccupancyLabel: "താമസം തുടങ്ങിയ തീയതി",
    dateHint: "അവർ ഇതിനകം ഇവിടെ താമസിക്കുന്നുണ്ടെങ്കിൽ, യഥാർത്ഥത്തിൽ മാറി വന്ന തീയതി തിരഞ്ഞെടുക്കുക — ഇന്നത്തെ തീയതിയല്ല.",
    rentDueDayLabel: "വാടക അടയ്ക്കേണ്ട തീയതി",
    rentDueDayHint: "മാസത്തിൽ വാടക അടയ്ക്കേണ്ട ദിവസം (1–31). ഡിഫോൾട്ടായി താമസം തുടങ്ങിയ തീയതി ആയിരിക്കും.",
    noticePeriodLabel: "നോട്ടീസ് പിരീഡ് (ദിവസങ്ങൾ)",
    noticePeriodHint: "ടെனന്റ് ഒഴിയുന്നതിന് മുമ്പ് എത്ര നോട്ടീസ് നൽകണം. ഡിഫോൾട്ടായി 60 ദിവസം (2 മാസം) ആയിരിക്കും.",
    addTenantButton: "ടെനന്റിനെ ചേർക്കുക",
  },
  addPropertyForm: {
    errNameRequired: "പ്രോപ്പർട്ടിക്ക് ഒരു പേര് നൽകുക",
    errLocalityRequired: "ലൊക്കാലിറ്റി നൽകുക",
    errCityRequired: "നഗരം നൽകുക",
    errStateRequired: "സംസ്ഥാനം തിരഞ്ഞെടുക്കുക",
    errPincodeRequired: "പിൻകോഡ് നൽകുക",
    errFurnishingRequired: "ഫർണിഷിംഗ് സ്ഥിതി തിരഞ്ഞെടുക്കുക",
    errCommunityTypeRequired: "കമ്മ്യൂണിറ്റി തരം തിരഞ്ഞെടുക്കുക",
    errRentRequired: "പ്രതീക്ഷിക്കുന്ന വാടക നൽകുക",
    errDepositRequired: "പ്രതീക്ഷിക്കുന്ന ഡെപ്പോസിറ്റ് നൽകുക",
    upgradeNowBtn: "ഇപ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യുക",
    heading: "പ്രോപ്പർട്ടി ചേർക്കുക",
    localityLabel: "ലൊക്കാലിറ്റി",
    localityPlaceholder: "ഉദാ. ഇന്ദിരാനഗർ, ബെംഗളൂരു",
    cityLabel: "നഗരം",
    cityPlaceholder: "ഉദാ. ബെംഗളൂരു",
    stateLabel: "സംസ്ഥാനം",
    statePlaceholder: "സംസ്ഥാനം തിരഞ്ഞെടുക്കുക",
    pincodeLabel: "പിൻകോഡ്",
    pincodePlaceholder: "6 അക്ക പിൻകോഡ്",
    chipIndependent: "ഇൻഡിപെൻഡന്റ്",
    chipPgHostel: "പിജി / ഹോസ്റ്റൽ",
    chipCommercial: "കൊമേഴ്‌സ്യൽ",
    propertyNameLabel: "പ്രോപ്പർട്ടിയുടെ പേര്",
    propertyNamePlaceholder: "ഉദാ. 3, റോസ്‌വുഡ് അപ്പാർട്ട്‌മെന്റ്‌സ്",
    typeLabel: "തരം",
    expectedRentLabel: "പ്രതീക്ഷിക്കുന്ന വാടക",
    expectedDepositLabel: "പ്രതീക്ഷിക്കുന്ന ഡെപ്പോസിറ്റ്",
    maintenanceLabel: "മെയിന്റനൻസ് / മാസം (ഓപ്ഷണൽ)",
    maintenancePlaceholder: "ഉദാ. 1500",
    multiUnitChip: "ഈ പ്രോപ്പർട്ടിയിൽ ഒന്നിലധികം വീടുകൾ ഉണ്ട്",
    multiUnitHint: "വാടകയ്ക്ക് ഒന്നിലധികം സ്വതന്ത്ര വീടുകൾ/ഫ്ലാറ്റുകൾ ഉള്ള കോമ്പൗണ്ട് അല്ലെങ്കിൽ കെട്ടിടത്തിന് — ഓരോന്നിനും അതിന്റേതായ വാടക, ഡെപ്പോസിറ്റ്, ടെനന്റ് ഉണ്ടാകും.",
    commercialDetailsHeading: "കൊമേഴ്‌സ്യൽ വിവരങ്ങൾ",
    carpetAreaLabel: "കാർപെറ്റ് ഏരിയ (ചതുരശ്ര അടി)",
    builtUpAreaLabel: "ബിൽറ്റ്-അപ്പ് ഏരിയ (ചതുരശ്ര അടി)",
    lockInMonthsLabel: "ലോക്ക്-ഇൻ കാലയളവ് (മാസങ്ങൾ)",
    rentEscalationPercentLabel: "വാടക വർദ്ധനവ് (%)",
    rentEscalationYearsLabel: "എത്ര വർഷം കൂടുമ്പോൾ വർദ്ധനവ്",
    possessionStatusLabel: "പൊസഷൻ സ്ഥിതി",
    possession_ready: "ഉടൻ ലഭ്യം",
    possession_under_fitout: "ഫിറ്റ്-ഔട്ട് നടക്കുന്നു",
    washroomTypeLabel: "വാഷ്‌റൂം",
    washroom_attached: "അറ്റാച്ഡ്",
    washroom_shared: "ഷെയേർഡ്",
    commercialAmenitiesLabel: "സൗകര്യങ്ങൾ",
    powerBackupChip: "പവർ ബാക്കപ്പ്",
    powerLoadDetailsLabel: "പവർ ബാക്കപ്പ് വിശദാംശങ്ങൾ (ഓപ്ഷണൽ)",
    powerLoadDetailsPlaceholder: "ഉദാ. 3-ഫേസ്, 100% DG ബാക്കപ്പ്",
    parkingSpotsLabel: "റിസർവ് ചെയ്ത പാർക്കിംഗ് (കാർ/ബൈക്ക്)",
    gstChip: "വാടകയിൽ 18% GST ബാധകം",
    frontageChip: "ഫ്രണ്ടേജ് / സൈനേജ് അവകാശം",
    seatsCountLabel: "സീറ്റുകൾ",
    cabinsCountLabel: "ക്യാബിനുകൾ",
    meetingRoomsCountLabel: "മീറ്റിംഗ് റൂമുകൾ",
    housesHeading: "വീടുകൾ",
    addHouseLink: "+ വീട് ചേർക്കുക ›",
    houseNameLabel: "വീടിന്റെ പേര്",
    hasExistingTenantChip: "ഈ പ്രോപ്പർട്ടിയിൽ നിലവിൽ ഒരു ടെനന്റ് ഉണ്ട്",
    tenantNameLabel: "ടെനന്റിന്റെ പേര്",
    phoneLabel: "ഫോൺ (രജിസ്റ്റർ ചെയ്തിട്ടുണ്ടെങ്കിൽ അവരുടെ ToLetBook അക്കൗണ്ടുമായി പൊരുത്തപ്പെടും)",
    phonePlaceholder: "10 അക്ക നമ്പർ",
    aadhaarLabel: "ആധാർ (ഓപ്ഷണൽ)",
    dateOfOccupancyLabel: "താമസം തുടങ്ങിയ തീയതി",
    dateHint: "അവർ യഥാർത്ഥത്തിൽ മാറി വന്ന തീയതി — വാടകയും ഡെപ്പോസിറ്റും മുകളിൽ നൽകിയ പ്രതീക്ഷിക്കുന്ന മൂല്യങ്ങൾ ഉപയോഗിക്കും.",
    occupancyLabel: "ഒക്യുപൻസി",
    occBoys: "ബോയ്സ്",
    occGirls: "ഗേൾസ്",
    occCoEd: "കോ-എഡ്",
    roomsHeading: "മുറികൾ",
    addRoomLink: "+ മുറി ചേർക്കുക ›",
    sharingTypeLabel: "ഷെയറിംഗ് തരം",
    rentPerBedLabel: "വാടക/ബെഡ്",
    depositPerBedLabel: "ഡെപ്പോസിറ്റ്/ബെഡ്",
    bedsLabel: "ബെഡുകൾ",
    mealPlanLabel: "ഭക്ഷണം ഉൾപ്പെടുന്നു",
    preferredTenantsLabel: "ഇഷ്ടപ്പെടുന്ന ടെനന്റുകൾ",
    meal_breakfast: "ബ്രേക്ക്ഫാസ്റ്റ്",
    meal_lunch: "ലഞ്ച്",
    meal_dinner: "ഡിന്നർ",
    tenantType_student: "സ്റ്റുഡന്റ്",
    tenantType_professional: "വർക്കിംഗ് പ്രൊഫഷണൽ",
    roomAc: "എസി",
    roomAttachedBathroom: "അറ്റാച്ഡ് ബാത്ത്റൂം",
    addPropertyButton: "പ്രോപ്പർട്ടി ചേർക്കുക",
  },
  ownerLedgers: {
    justNow: "ഇപ്പോൾ തന്നെ",
    minsAgo: "{mins} മിനിറ്റ് മുമ്പ്",
    hoursAgo: "{hours} മണിക്കൂർ മുമ്പ്",
    daysAgo: "{days} ദിവസം മുമ്പ്",
    emptyNoProperty: "നോട്ട്ബുക്ക് ട്രാക്ക് ചെയ്യാൻ ആദ്യം ഒരു പ്രോപ്പർട്ടി ചേർക്കുക.",
    heading: "നോട്ട്ബുക്ക്",
    emptyNoTenants: "ഇവിടെ ഇതുവരെ ടെനന്റുകൾ ഇല്ല.",
    markedPaid: "അടച്ചു എന്ന് മാർക്ക് ചെയ്തു",
    reminderSent: "ടെനന്റിന് റിമൈൻഡർ അയച്ചു",
    emptyNoActiveTenants: "ഇവിടെ ഇതുവരെ ആക്ടീവ് ടെനന്റുകൾ ഇല്ല.",
    otherCategory: "മറ്റുള്ളവ",
    pastTenantsHeading: "പഴയ ടെനന്റുകൾ · {count}",
    rentLedgerLabel: "വാടക ലെഡ്ജർ · കഴിഞ്ഞ 12 മാസം",
    paidFraction: "{paid}/{total} അടച്ചു",
    entriesLabel: "എൻട്രികൾ",
    rentPaid: "വാടക അടച്ചു",
    rentDue: "വാടക ബാക്കിയുണ്ട്",
    markReceived: "കിട്ടി എന്ന് മാർക്ക് ചെയ്യുക (ക്യാഷ്)",
    markingBusy: "മാർക്ക് ചെയ്യുന്നു…",
    remindAgain: "🔔 വീണ്ടും ഓർമ്മിപ്പിക്കുക",
    remind: "🔔 ഓർമ്മിപ്പിക്കുക",
    sendingBusy: "അയക്കുന്നു…",
    remindedAgo: "{time} ഓർമ്മിപ്പിച്ചു",
    closeButton: "‹ അടയ്ക്കുക",
    refundLabel: "റീഫണ്ട്",
    refundedAmount: "{amount} റീഫണ്ട് ചെയ്തു",
  },
  ownerReports: {
    emptyState: "ഇതുവരെ ലെഡ്ജർ ആക്ടിവിറ്റി ഇല്ല — പിരിവ് തുടങ്ങാൻ ഒരു ടെനന്റിനെ ചേർക്കുക.",
    heading: "റിപ്പോർട്ടുകൾ",
    collected: "പിരിച്ചെടുത്തു",
    pending: "ബാക്കിയുണ്ട്",
    paidOnRecord: "രേഖയിൽ അടച്ചത്",
    collectionsByMonth: "മാസം അനുസരിച്ചുള്ള പിരിവ്",
    monthTooltip: "{month}: {collected} പിരിച്ചെടുത്തു, {pending} ബാക്കിയുണ്ട്",
    byProperty: "പ്രോപ്പർട്ടി അനുസരിച്ച്",
    pendingAmount: "{amount} ബാക്കിയുണ്ട്",
    exportCsvButton: "ലെഡ്ജർ CSV ആയി എക്സ്പോർട്ട് ചെയ്യുക",
    hint: "ഓരോ വരിയും ഒരു ലെഡ്ജർ എൻട്രിയിലേക്ക് പോകുന്നു — ഇവിടെ പ്രത്യേകം കണക്കുകൾ ചേർത്തിട്ടില്ല.",
  },
  ownerRequests: {
    visitRequestsHeading: "വിസിറ്റ് റിക്വസ്റ്റുകൾ",
    newCount: "{count} പുതിയത്",
    emptyNoVisits: "ഇതുവരെ വിസിറ്റ് റിക്വസ്റ്റുകൾ ഇല്ല.",
    maintenanceRequestsHeading: "മെയിന്റനൻസ് റിക്വസ്റ്റുകൾ",
    emptyNoRequests: "ഇതുവരെ റിക്വസ്റ്റുകൾ ഒന്നും അയച്ചിട്ടില്ല.",
    noDetailsProvided: "വിവരങ്ങൾ നൽകിയിട്ടില്ല",
    startWork: "ജോലി തുടങ്ങുക",
    markResolved: "പരിഹരിച്ചു എന്ന് മാർക്ക് ചെയ്യുക",
    requestUpdated: "റിക്വസ്റ്റ് അപ്ഡേറ്റ് ചെയ്തു",
    visitConfirmed: "വിസിറ്റ് കൺഫേം ചെയ്തു",
    visitDeclined: "വിസിറ്റ് നിരസിച്ചു",
    noPhoneOnFile: "ഫോൺ നമ്പർ രേഖപ്പെടുത്തിയിട്ടില്ല",
    visitLine: "{property} · {date} {time}-ന്",
    declineButton: "നിരസിക്കുക",
    confirmButton: "കൺഫേം ചെയ്യുക",
    statusOpen: "ഓപ്പൺ",
    statusInProgress: "പുരോഗതിയിൽ",
    statusResolved: "പരിഹരിച്ചു",
    visitStatusPending: "ബാക്കിയുണ്ട്",
    visitStatusConfirmed: "കൺഫേം ചെയ്തു",
    visitStatusDeclined: "നിരസിച്ചു",
    visitStatusCancelled: "ക്യാൻസൽ ചെയ്തു",
    vacateRequestsHeading: "ഒഴിയൽ നോട്ടീസുകൾ",
    emptyNoVacates: "ഇതുവരെ ഒഴിയൽ നോട്ടീസുകൾ ഇല്ല.",
    vacateLine: "{property} · {date}-ന് ഒഴിയും",
    noticeGivenLine: "{date}-ന് നോട്ടീസ് നൽകി",
    acknowledgeButton: "അംഗീകരിക്കുക",
    vacateAcknowledged: "ഒഴിയൽ നോട്ടീസ് അംഗീകരിച്ചു",
    vacateStatusPending: "ബാക്കിയുണ്ട്",
    vacateStatusAcknowledged: "അംഗീകരിച്ചു",
    vacateStatusCancelled: "ക്യാൻസൽ ചെയ്തു",
  },
  editPropertyForm: {
    errNameRequired: "പ്രോപ്പർട്ടിക്ക് ഒരു പേര് നൽകുക",
    propertyUpdated: "പ്രോപ്പർട്ടി അപ്ഡേറ്റ് ചെയ്തു",
    couldNotUpdate: "പ്രോപ്പർട്ടി അപ്ഡേറ്റ് ചെയ്യാനായില്ല",
    localityLabel: "ലൊക്കാലിറ്റി",
    propertyNameLabel: "പ്രോപ്പർട്ടിയുടെ പേര്",
    typeLabel: "തരം",
    residentialGroup: "റെസിഡൻഷ്യൽ",
    commercialGroup: "കൊമേഴ്‌സ്യൽ",
    expectedRentLabel: "പ്രതീക്ഷിക്കുന്ന വാടക",
    expectedDepositLabel: "പ്രതീക്ഷിക്കുന്ന ഡെപ്പോസിറ്റ്",
    maintenanceLabel: "മെയിന്റനൻസ് / മാസം (ഓപ്ഷണൽ)",
    occupancyLabel: "ഒക്യുപൻസി",
    occBoys: "ബോയ്സ്",
    occGirls: "ഗേൾസ്",
    occCoEd: "കോ-എഡ്",
    facilitiesLabel: "സൗകര്യങ്ങൾ",
    facility_wifi: "വൈ-ഫൈ",
    facility_meals: "ഭക്ഷണം",
    facility_laundry: "അലക്ക്",
    facility_powerBackup: "പവർ ബാക്കപ്പ്",
    facility_cctv: "സിസിടിവി",
    facility_parking: "പാർക്കിംഗ്",
    facility_ac: "എസി",
    facility_tv: "ടിവി",
    facility_washingMachine: "വാഷിംഗ് മെഷീൻ",
    perHouseFurnishingHint: "ഫർണിഷിംഗ് ഓരോ വീടിനും പ്രത്യേകം സെറ്റ് ചെയ്യുന്നു — താഴെ ഓരോ വീടും തുറന്ന് സെറ്റ് ചെയ്യുക.",
    furnishingStatusLabel: "ഫർണിഷിംഗ്",
    furnishing_unfurnished: "അൺഫർണിഷ്ഡ്",
    furnishing_semi_furnished: "സെമി-ഫർണിഷ്ഡ്",
    furnishing_fully_furnished: "ഫുള്ളി ഫർണിഷ്ഡ്",
    commercialFurnishing_unfurnished: "ബെയർ ഷെൽ",
    commercialFurnishing_semi_furnished: "വാം ഷെൽ",
    commercialFurnishing_fully_furnished: "ഫുള്ളി ഫർണിഷ്ഡ്",
    communityTypeLabel: "കമ്യൂണിറ്റി ടൈപ്പ്",
    community_gated: "ഗേറ്റഡ് കമ്യൂണിറ്റി",
    community_semi_gated: "സെമി ഗേറ്റഡ് കമ്യൂണിറ്റി",
    community_villa: "വില്ല",
    community_apartment: "അപ്പാർട്ട്മെന്റ്",
    community_independent: "ഇൻഡിപെൻഡന്റ്",
    floorNumberLabel: "നില",
    floorNumberPlaceholder: "ഉദാ. 3 അല്ലെങ്കിൽ ഗ്രൗണ്ട്",
    floorChipLabel: "നില {floor}",
    furnishingItemsLabel: "ഫർണിച്ചർ & ഉപകരണങ്ങൾ",
    furnishingItemsHint: "വാടകക്കാരന് ഓരോന്നും എത്ര ഉണ്ടാകും എന്ന് നൽകുക.",
    item_fan: "ഫാനുകൾ",
    item_light: "ലൈറ്റുകൾ",
    item_ac: "എസി",
    item_fridge: "ഫ്രിഡ്ജ്",
    item_washingMachine: "വാഷിംഗ് മെഷീൻ",
    item_sofa: "സോഫ",
    item_bed: "ബെഡ്",
    item_heater: "വാട്ടർ ഹീറ്റർ (ബാത്ത്റൂം)",
    item_chimney: "ചിമ്മിനി (കിച്ചൺ)",
    addFurnitureItemPlaceholder: "+ ഫർണിച്ചർ / ഉപകരണം ചേർക്കുക",
    customItemNamePlaceholder: "ഉദാ. സ്റ്റഡി ടേബിൾ",
    addCustomItemBtn: "+ മറ്റൊരു ഇനം ചേർക്കുക",
  },
  endTenancyForm: {
    tenancyEnded: "ടെനൻസി അവസാനിച്ചു — റീഫണ്ട് വിവരങ്ങൾ ടെനന്റിന് അയച്ചു",
    couldNotEnd: "ടെനൻസി അവസാനിപ്പിക്കാനായില്ല",
    heading: "ടെനൻസി അവസാനിപ്പിക്കുക — {name}",
    dateOfExitLabel: "പോകുന്ന തീയതി",
    depositPaidLabel: "അടച്ച ഡെപ്പോസിറ്റ്",
    deductionsLabel: "കിഴിവുകൾ (നാശനഷ്ടം, ബാക്കി തുടങ്ങിയവ)",
    deductionNoteLabel: "കിഴിവിന്റെ കുറിപ്പ് (ഓപ്ഷണൽ)",
    deductionNotePlaceholder: "ഉദാ. ചുവരിന്റെ പെയിന്റ് ടച്ച്-അപ്പ്",
    refundableDepositLabel: "തിരികെ കിട്ടുന്ന ഡെപ്പോസിറ്റ്",
    confirmButton: "കൺഫേം ചെയ്ത് ടെനൻസി അവസാനിപ്പിക്കുക",
    endingBusy: "അവസാനിപ്പിക്കുന്നു…",
  },
  propertyPhotos: {
    uploadFailed: "അപ്‌ലോഡ് പരാജയപ്പെട്ടു",
    photoRemoved: "ഫോട്ടോ നീക്കി",
    couldNotRemove: "ഫോട്ടോ നീക്കാനായില്ല",
    removePhotoAria: "ഫോട്ടോ നീക്കുക",
  },
  photoStager: {
    photosLabel: "ഫോട്ടോകൾ (ഓപ്ഷണൽ)",
    couldNotRead: "ആ ഇമേജ് വായിക്കാനായില്ല",
    removePhotoAria: "ഫോട്ടോ നീക്കുക",
  },
  photoPickerButtons: {
    addPhotoTitle: "ഒരു ഫോട്ടോ ചേർക്കുക",
    takePhoto: "📷 ഫോട്ടോ എടുക്കുക",
    chooseFromFiles: "🖼 ഫയലുകളിൽ നിന്ന് തിരഞ്ഞെടുക്കുക",
  },
  ownerPlans: {
    title: "പ്ലാനുകൾ",
    currentPlanLabel: "നിലവിലെ പ്ലാൻ",
    trialBadge: "സൗജന്യ പ്രീമിയം ട്രയൽ",
    trialEndsOn: "ട്രയൽ {date}ന് അവസാനിക്കും",
    renewsOn: "{date}ന് പുതുക്കും",
    listingsUsed: "{cap}ൽ {used} ലിസ്റ്റിംഗുകൾ ഉപയോഗിച്ചു",
    billingMonthly: "പ്രതിമാസം",
    billingYearly: "വാർഷികം · ~16% ലാഭിക്കൂ",
    basicName: "ബേസിക്",
    proName: "പ്രോ",
    premiumName: "പ്രീമിയം",
    mostPopular: "ഏറ്റവും ജനപ്രിയം",
    powerOwners: "പവർ ഓണർമാർ",
    basicSub: "ഇപ്പോൾ തുടങ്ങുന്ന ഓണർമാർക്ക്",
    proSub: "കുറച്ച് പ്രോപ്പർട്ടികളുള്ള ഓണർമാർക്ക്",
    premiumSub: "നിരവധി പ്രോപ്പർട്ടികൾ കൈകാര്യം ചെയ്യുന്ന ഓണർമാർക്ക്",
    featListing1: "1 ആക്ടീവ് ലിസ്റ്റിംഗ്",
    featListing3: "3 വരെ ആക്ടീവ് ലിസ്റ്റിംഗുകൾ",
    featListingUnlimited: "അൺലിമിറ്റഡ് ലിസ്റ്റിംഗുകൾ",
    featEnquiries: "ടെനന്റ് അന്വേഷണങ്ങളും വിസിറ്റ് റിക്വസ്റ്റുകളും",
    featLedger: "വാടക പിരിവും ഡിജിറ്റൽ ലെഡ്ജറും",
    featAgreement: "സെൽഫ്-സെർവ് റെന്റൽ അഗ്രിമെന്റ് ജനറേറ്റർ — ഉടൻ വരുന്നു",
    featMarketplace: "TO-LET മാർക്കറ്റ്‌പ്ലേസിൽ ദൃശ്യമാണ്",
    featEverythingBasic: "ബേസിക്കിലുള്ള എല്ലാം",
    featEverythingPro: "പ്രോയിലുള്ള എല്ലാം",
    featMarketplaceSwitch: "TO-LET മാർക്കറ്റ്‌പ്ലേസ് സ്വിച്ച് — എപ്പോൾ വേണമെങ്കിലും ലൈവ് ചെയ്യൂ",
    featFeatured: "സെർച്ചിൽ ഫീച്ചേഡ് പ്ലേസ്‌മെന്റ്",
    featPriority: "സമാന-പ്രോപ്പർട്ടി നിർദ്ദേശങ്ങളിൽ മുൻഗണന",
    featTopListing: "ടോപ്പ് ലിസ്റ്റിംഗ് — മാർക്കറ്റ്‌പ്ലേസ് സെർച്ചിന്റെ ഏറ്റവും മുകളിൽ പിൻ ചെയ്തത്",
    featPriorityAgreement: "മുൻഗണനാ റെന്റൽ അഗ്രിമെന്റ് സേവനം (നിയമപരമായി അവലോകനം ചെയ്തത്, വേഗത്തിലുള്ള ടേണറൗണ്ട്) — ഉടൻ വരുന്നു",
    featPriorityVerification: "മുൻഗണനാ ഐഡന്റിറ്റി-വെരിഫിക്കേഷൻ അവലോകനം",
    featPrioritySupport: "മുൻഗണനാ സപ്പോർട്ട്",
    currentPlanBtn: "നിലവിലെ പ്ലാൻ",
    switchToBtn: "{plan}ലേക്ക് മാറുക",
    noChargeNote: "ഇതുവരെ പേയ്‌മെന്റ് ആവശ്യമില്ല — ബില്ലിംഗ് സെറ്റപ്പ് ചെയ്യുന്നത് വരെ പ്ലാൻ മാറ്റുന്നത് സൗജന്യമാണ്.",
    switchedToast: "{plan} പ്ലാനിലേക്ക് മാറി",
    switchFailedToast: "പ്ലാൻ മാറ്റാൻ കഴിഞ്ഞില്ല",
    trialActiveNote: "നിങ്ങൾ ഒരു സൗജന്യ പ്രീമിയം ട്രയലിലാണ് — അത് അവസാനിക്കുന്നത് വരെ എല്ലാ പ്രീമിയം ഫീച്ചറും അൺലോക്ക് ചെയ്തിരിക്കുന്നു.",
    cancelPlanBtn: "പ്ലാൻ റദ്ദാക്കുക",
    securePaymentNote: "പേയ്‌മെന്റുകൾ Razorpay വഴി സുരക്ഷിതമായി പ്രോസസ്സ് ചെയ്യുന്നു.",
  },
  tenantHome: {
    moveOutSettlement: "മൂവ്-ഔട്ട് സെറ്റിൽമെന്റ്",
    yourLastPlace: "നിങ്ങളുടെ അവസാന താമസസ്ഥലം",
    depositPaid: "അടച്ച ഡെപ്പോസിറ്റ്",
    deductionsLabel: "കിഴിവുകൾ",
    refundableDeposit: "തിരികെ കിട്ടുന്ന ഡെപ്പോസിറ്റ്",
    exitedOn: "{date}-ന് ഒഴിഞ്ഞു",
    noActiveTenancyLine1: "നിങ്ങൾക്ക് ഇപ്പോൾ ആക്ടീവ് ടെനൻസി ഇല്ല.",
    noActiveTenancyLine2: "താമസസ്ഥലം കണ്ടെത്താൻ ലിസ്റ്റിംഗുകൾ ബ്രൗസ് ചെയ്യുക, അല്ലെങ്കിൽ മാറി വന്നതിന് ശേഷം നിങ്ങളെ ചേർക്കാൻ ഓണറോട് ആവശ്യപ്പെടുക.",
    welcomeTitle: "ToLetBook-ലേക്ക് സ്വാഗതം!",
    welcomeSub: "നിങ്ങൾക്കായി ഒരു വാടക പ്രോപ്പർട്ടി കണ്ടെത്താം.",
    browsePropertiesBtn: "പ്രോപ്പർട്ടികൾ ബ്രൗസ് ചെയ്യുക",
    rentForMonth: "{month}-ലെ വാടക",
    paidStatus: "അടച്ചു",
    dueStatus: "ബാക്കിയുണ്ട്",
    overdueStatus: "കാലാവധി കഴിഞ്ഞു",
    dueInDays: "{count} ദിവസത്തിനുള്ളിൽ അടയ്ക്കണം",
    dueTodayLabel: "ഇന്ന് അടയ്ക്കണം",
    overdueByDays: "{count} ദിവസം കഴിഞ്ഞു",
    reminderBanner: "🔔 ഈ പേയ്‌മെന്റിനെക്കുറിച്ച് നിങ്ങളുടെ ഓണർ ഒരു റിമൈൻഡർ അയച്ചു",
    paidCheck: "✓ അടച്ചു",
    onDate: "{date}-ന്",
    viaMode: "{mode} വഴി",
    receiptBtn: "രസീത്",
    payingBtn: "അടയ്ക്കുന്നു…",
    payAmount: "{amount} അടയ്ക്കുക",
    paymentRecordedToast: "പേയ്‌മെന്റ് രേഖപ്പെടുത്തി",
    ownerLabel: "ഓണർ",
    callOwnerAria: "ഓണറെ വിളിക്കുക",
    raiseRequest: "റിക്വസ്റ്റ് അയയ്ക്കുക",
    viewLease: "എഗ്രിമെന്റ് കാണുക",
    receiptsNav: "രസീതുകൾ",
    browseRooms: "മുറികൾ ബ്രൗസ് ചെയ്യുക",
    openRequestsHeading: "ഓപ്പൺ റിക്വസ്റ്റുകൾ",
    viewAll: "എല്ലാം കാണുക",
    noOpenRequests: "ഓപ്പൺ റിക്വസ്റ്റുകൾ ഇല്ല.",
    noDetailsProvided: "വിവരങ്ങൾ നൽകിയിട്ടില്ല",
  },
  tenantBrowse: {
    occBoys: "ബോയ്സ് പിജി",
    occGirls: "ഗേൾസ് പിജി",
    occCoEd: "കോ-എഡ് പിജി",
    occDefault: "പിജി",
    filterAll: "എല്ലാം",
    filterPg: "പിജി",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "വില്ല",
    filterShop: "കട",
    filterOffice: "ഓഫീസ്",
    filterShowroom: "ഷോറൂം",
    filterWarehouse: "വെയർഹൗസ്",
    filterCoworking: "കോ-വർക്കിംഗ്",
    filterFactory: "ഫാക്ടറി",
    sortDefault: "ഡിഫോൾട്ട്",
    sortPriceAsc: "വില: കുറഞ്ഞത് മുതൽ കൂടിയത് വരെ",
    sortPriceDesc: "വില: കൂടിയത് മുതൽ കുറഞ്ഞത് വരെ",
    sortDistance: "ദൂരം: ഏറ്റവും അടുത്തത്",
    locationNotSupported: "ഈ ബ്രൗസറിൽ ലൊക്കേഷൻ സപ്പോർട്ട് ചെയ്യുന്നില്ല",
    locationPermissionDenied: "ലൊക്കേഷൻ അനുമതി നിഷേധിച്ചു",
    locationCouldNotGet: "നിങ്ങളുടെ ലൊക്കേഷൻ കണ്ടെത്താനായില്ല",
    heading: "നിങ്ങൾക്കായി ToLets കണ്ടെത്താം",
    searchPlaceholder: "ലൊക്കാലിറ്റി അല്ലെങ്കിൽ പ്രോപ്പർട്ടി പേര് ഉപയോഗിച്ച് തിരയുക",
    filtersBtn: "⚙ ഫിൽട്ടറുകൾ",
    listView: "☰ ലിസ്റ്റ് വ്യൂ",
    mapView: "🗺️ മാപ്പ് വ്യൂ",
    fromPrice: "{price} മുതൽ",
    housesCount: "{count} വീടുകൾ",
    noVacancies: "ഇപ്പോൾ ഒഴിവുകൾ ഇല്ല — പിന്നീട് നോക്കുക.",
    noMatch: "നിങ്ങളുടെ സേർച്ചോ ഫിൽട്ടറോ ചേരുന്ന ലിസ്റ്റിംഗുകൾ ഇല്ല.",
    noPinnedLocation: "ഇവയിൽ ഒരു ലിസ്റ്റിംഗിനും ഇതുവരെ ലൊക്കേഷൻ പിൻ ചെയ്തിട്ടില്ല.",
    distanceAway: "{value} അകലെ",
    filtersTitle: "ഫിൽട്ടറുകൾ",
    propertyTypeLabel: "പ്രോപ്പർട്ടി തരം",
    sortByLabel: "ഇതനുസരിച്ച് സോർട്ട് ചെയ്യുക",
    yourLocationLabel: "നിങ്ങളുടെ ലൊക്കേഷൻ",
    locating: "ലൊക്കേഷൻ കണ്ടെത്തുന്നു…",
    locationOn: "📍 ലൊക്കേഷൻ ഓണാണ്",
    useMyLocation: "📍 എന്റെ ലൊക്കേഷൻ ഉപയോഗിക്കുക",
    nearLabel: "📍 {location}-ന് സമീപം",
    clearAll: "എല്ലാം ക്ലിയർ ചെയ്യുക",
    showResults: "ഫലങ്ങൾ കാണിക്കുക",
    backToListings: "‹ ലിസ്റ്റിംഗുകളിലേക്ക് തിരികെ",
    housesHeading: "വീടുകൾ",
    occupiedBadge: "നിറഞ്ഞു",
    vacantBadge: "ഒഴിവുണ്ട്",
    typeLabel: "തരം",
    rentLabel: "വാടക",
    perMonthSuffix: "/മാസം",
    depositLabel: "ഡെപ്പോസിറ്റ്",
    escalationLabel: "വാടക വർദ്ധനവ്",
    yearsSuffix: "വർഷം",
    occupancyLabel: "ഒക്യുപൻസി",
    mealPlanLabel: "ഭക്ഷണം ഉൾപ്പെടുന്നു",
    preferredTenantsLabel: "ഇഷ്ടപ്പെടുന്ന ടെനന്റുകൾ",
    roomAc: "എസി",
    roomAttachedBathroom: "അറ്റാച്ഡ് ബാത്ത്റൂം",
    bedsVacant: "{total}-ൽ {vacant} ബെഡുകൾ ഒഴിവുണ്ട്",
    locationLabel: "ലൊക്കേഷൻ",
    openInGoogleMaps: "Google Maps-ൽ തുറക്കുക",
    viewOnMap: "മാപ്പിൽ കാണുക",
    hideMap: "മാപ്പ് മറയ്ക്കുക",
    showNearby: "സമീപത്ത് എന്തുണ്ടെന്ന് കാണുക",
    hideNearby: "സമീപ സ്ഥലങ്ങൾ മറയ്ക്കുക",
    loadingNearby: "സമീപ സ്ഥലങ്ങൾ തിരയുന്നു…",
    nearbyEmpty: "സമീപത്ത് സ്ഥലങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
    nearbyTransit: "ട്രാൻസിറ്റ്",
    nearbyEssentials: "അവശ്യവസ്തുക്കൾ",
    nearbyHealthcare: "ആരോഗ്യ സംരക്ഷണം",
    metersAway: "{distance} മീ അകലെ",
    similarPropertiesHeading: "സമാന പ്രോപ്പർട്ടികൾ",
    topTag: "ടോപ്പ്",
    featuredTag: "ഫീച്ചേഡ്",
    moveInHint: "മാറിത്താമസിക്കാൻ, നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഫോൺ നമ്പർ ഉപയോഗിച്ച് നിങ്ങളെ ടെനന്റായി ചേർക്കാൻ ഓണറോട് ആവശ്യപ്പെടുക — അതിന് ശേഷം ഇത് നിങ്ങളുടെ ഹോം ടാബിൽ താനെ കാണിക്കും.",
    scheduleVisit: "ഒരു വിസിറ്റ് ഷെഡ്യൂൾ ചെയ്യുക",
    pickDateTime: "ഒരു തീയതിയും സമയവും തിരഞ്ഞെടുക്കുക",
    visitRequestSent: "വിസിറ്റ് റിക്വസ്റ്റ് ഓണർക്ക് അയച്ചു",
    couldNotSendVisit: "വിസിറ്റ് റിക്വസ്റ്റ് അയക്കാനായില്ല",
    requestedFor: "{date} {time}-ന് വേണ്ടി റിക്വസ്റ്റ് ചെയ്തു — ഓണറെ അറിയിച്ചിട്ടുണ്ട്, അവർ കൺഫേം ചെയ്യും.",
    dateLabel: "തീയതി",
    timeLabel: "സമയം",
    noteOptionalLabel: "കുറിപ്പ് (ഓപ്ഷണൽ)",
    notePlaceholder: "ഉദാ. വൈകുന്നേരം വേണം, മുൻകൂട്ടി വിളിക്കും",
    sending: "അയക്കുന്നു…",
    requestVisitBtn: "വിസിറ്റ് റിക്വസ്റ്റ് ചെയ്യുക",
    ownerContactLabel: "ഓണർ",
    verifiedOwnerBadge: "വെരിഫൈഡ്",
    unlockingBtn: "അൺലോക്ക് ചെയ്യുന്നു…",
    unlockNumberFreeBtn: "🔓 നമ്പർ അൺലോക്ക് ചെയ്യുക — സൗജന്യം",
    unlockUpsellTitle: "സൗജന്യ അൺലോക്ക് ഉപയോഗിച്ചുകഴിഞ്ഞു",
    unlockUpsellBody: "ബേസിക് പ്ലാനിൽ 1 ഓണറുടെ കോൺടാക്റ്റ് സൗജന്യമായി അൺലോക്ക് ചെയ്യാം. പരിധിയില്ലാതെ ഓണർമാരെ അൺലോക്ക് ചെയ്യാൻ Tenant Pro-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    unlockUpsellBtn: "Tenant Pro-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക",
    callNumberBtn: "{phone} വിളിക്കുക",
    whatsappBtn: "💬 WhatsApp-ൽ ചാറ്റ് ചെയ്യുക",
    whatsappMessage: "നമസ്കാരം, ToLetBook-ൽ ലിസ്റ്റ് ചെയ്ത നിങ്ങളുടെ പ്രോപ്പർട്ടി \"{property}\" എനിക്ക് താൽപ്പര്യമുണ്ട്. ഇത് ഇപ്പോഴും ലഭ്യമാണോ?",
    contactUnlockedToast: "കോൺടാക്റ്റ് നമ്പർ അൺലോക്ക് ചെയ്തു",
    couldNotUnlockToast: "കോൺടാക്റ്റ് അൺലോക്ക് ചെയ്യാനായില്ല",
  },
  tenantPayments: {
    noActiveTenancy: "വാടക അടയ്ക്കാൻ നിങ്ങൾക്ക് ആക്ടീവ് ടെനൻസി ഇല്ല.",
    title: "പേയ്‌മെന്റുകൾ",
    paidStatus: "അടച്ചു",
    rentDue: "വാടക ബാക്കിയുണ്ട്",
    reminderBanner: "🔔 ഈ പേയ്‌മെന്റിനെക്കുറിച്ച് നിങ്ങളുടെ ഓണർ ഒരു റിമൈൻഡർ അയച്ചു",
    payingBtn: "അടയ്ക്കുന്നു…",
    payViaUpi: "UPI വഴി {amount} അടയ്ക്കുക",
    payNow: "{amount} അടയ്ക്കുക",
    paymentFailedToast: "പേയ്‌മെന്റ് നടന്നില്ല — വീണ്ടും ശ്രമിക്കുക",
    paymentRecordedToast: "പേയ്‌മെന്റ് രേഖപ്പെടുത്തി",
    viewReceiptBtn: "രസീത് കാണുക",
    history: "ഹിസ്റ്ററി",
    payViaUpiDirectlyBtn: "നേരിട്ട് UPI വഴി അടയ്ക്കുക",
    ownerUpiIdLabel: "ഓണറുടെ UPI ID",
    copyUpiBtn: "കോപ്പി ചെയ്യുക",
    upiIdCopiedToast: "UPI ID കോപ്പി ചെയ്തു",
    openUpiAppBtn: "UPI ആപ്പ് തുറക്കുക",
    markPaidUpiBtn: "ഞാൻ UPI വഴി അടച്ചു",
    markPaidUpiConfirm: "ഈ വാടക ഓണറുടെ UPI ID യിലേക്ക് അയച്ചോ? ഇത് അടച്ചതായി അടയാളപ്പെടുത്തും.",
  },
  tenantRequests: {
    title: "മെയിന്റനൻസ് റിക്വസ്റ്റുകൾ",
    cancelLink: "റദ്ദാക്കുക ›",
    newLink: "+ പുതിയത് ›",
    whatsWrong: "എന്താണ് പ്രശ്നം?",
    issuePlaceholder: "ഉദാ. ടാപ്പിൽ നിന്ന് വെള്ളം ചോരുന്നു",
    detailsOptional: "വിവരങ്ങൾ (ഓപ്ഷണൽ)",
    submittingBtn: "സമർപ്പിക്കുന്നു…",
    submitRequestBtn: "റിക്വസ്റ്റ് സമർപ്പിക്കുക",
    giveTitleError: "റിക്വസ്റ്റിന് ഒരു ടൈറ്റിൽ നൽകുക",
    requestRaisedToast: "റിക്വസ്റ്റ് അയച്ചു",
    noRequestsYet: "ഇതുവരെ റിക്വസ്റ്റുകൾ ഒന്നും അയച്ചിട്ടില്ല.",
    noDetailsProvided: "വിവരങ്ങൾ നൽകിയിട്ടില്ല",
    myVisitsHeading: "എന്റെ വിസിറ്റ് റിക്വസ്റ്റുകൾ",
    emptyNoVisits: "നിങ്ങൾ ഇതുവരെ ഒരു പ്രോപ്പർട്ടി വിസിറ്റ് റിക്വസ്റ്റും ചെയ്തിട്ടില്ല.",
    visitLine: "{date}-ന് {time}-ന്",
    cancelVisitButton: "റദ്ദാക്കുക",
    visitCancelledToast: "വിസിറ്റ് റിക്വസ്റ്റ് റദ്ദാക്കി",
    visitStatusPending: "തീരുമാനമായിട്ടില്ല",
    visitStatusConfirmed: "സ്ഥിരീകരിച്ചു",
    visitStatusDeclined: "നിരസിച്ചു",
    visitStatusCancelled: "റദ്ദാക്കി",
    vacateNoticeHeading: "ഒഴിയൽ നോട്ടീസ്",
    giveNoticeLink: "+ നോട്ടീസ് നൽകുക ›",
    vacateOnLabel: "{date}-ന് ഒഴിയും",
    noticeGivenOnLabel: "{date}-ന് നോട്ടീസ് നൽകി",
    vacateStatusPending: "തീരുമാനമായിട്ടില്ല",
    vacateStatusAcknowledged: "അംഗീകരിച്ചു",
    vacateStatusCancelled: "റദ്ദാക്കി",
    shareWhatsappBtn: "💬 WhatsApp-ൽ ഷെയർ ചെയ്യുക",
    cancelNoticeBtn: "നോട്ടീസ് റദ്ദാക്കുക",
    noticeDateLabel: "നോട്ടീസ് തീയതി",
    vacateDatePreview: "നിങ്ങളുടെ {days}-ദിവസത്തെ നോട്ടീസ് പിരീഡ് അനുസരിച്ച്, നിങ്ങൾ {date}-ന് ഒഴിയും",
    submitVacateNoticeBtn: "ഒഴിയൽ നോട്ടീസ് സമർപ്പിക്കുക",
    vacateNoticeSentToast: "ഒഴിയൽ നോട്ടീസ് ഓണർക്ക് അയച്ചു",
    vacateNoticeCancelledToast: "ഒഴിയൽ നോട്ടീസ് റദ്ദാക്കി",
    emptyNoVacateNotices: "നിങ്ങൾ ഇതുവരെ ഒരു ഒഴിയൽ നോട്ടീസും നൽകിയിട്ടില്ല.",
    vacateWhatsappMessage: "നമസ്കാരം {owner}, ഞാൻ \"{property}\" ഒഴിയുന്നു എന്ന് ഔപചാരികമായി അറിയിക്കുന്നു. നോട്ടീസ് {noticeDate}-ന് നൽകി, {vacateDate}-ന് ഒഴിയും.",
  },
  tenantOnboarding: {
    title: "നിങ്ങളുടെ മൂവ്-ഇൻ പൂർത്തിയാക്കുക",
    nameLabel: "നിങ്ങളുടെ പേര് (ആധാർ പ്രകാരം)",
    nameHint: "ഈ കൃത്യമായ പേര് നിങ്ങളുടെ റെന്റൽ എഗ്രിമെന്റിൽ ഉപയോഗിക്കും.",
    rentLabel: "മാസ വാടക",
    dueDayLabel: "വാടക അടയ്ക്കേണ്ട ദിവസം",
    dueDayValue: "എല്ലാ മാസവും {day}-ാം തീയതി",
    depositLabel: "സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ്",
    depositPaidBadge: "അടച്ചു",
    depositPendingBadge: "ബാക്കിയുണ്ട്",
    depositConfirmingBadge: "സ്ഥിരീകരിക്കുന്നു…",
    payNowBtn: "ഇപ്പോൾ അടയ്ക്കുക",
    payingBtn: "പേയ്‌മെന്റ് തുറക്കുന്നു…",
    depositPaymentDesc: "സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ്",
    depositPaidToast: "ഡെപ്പോസിറ്റ് പേയ്‌മെന്റ് ലഭിച്ചു",
    depositFailedToast: "പേയ്‌മെന്റ് നടന്നില്ല — വീണ്ടും ശ്രമിക്കുക",
    depositPaidCashBadge: "ക്യാഷായി അടച്ചു",
    paidInCashLink: "ഞാൻ ക്യാഷായി അടച്ചു",
    cashProofHint: "രസീത് അല്ലെങ്കിൽ പേയ്‌മെന്റ് തെളിവ് ഫോട്ടോ ചേർക്കുക (ഐച്ഛികം).",
    cashProofUploadLabel: "തെളിവ് ചേർക്കുക",
    confirmCashBtn: "ക്യാഷ് പേയ്‌മെന്റ് സ്ഥിരീകരിക്കുക",
    errDepositRequired: "തുടരുന്നതിന് മുമ്പ് സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ് അടയ്ക്കുക (ഓൺലൈൻ അല്ലെങ്കിൽ ക്യാഷ്)",
    amenitiesLabel: "ഓണർ നൽകുന്ന സൗകര്യങ്ങൾ",
    identityVerificationLabel: "തിരിച്ചറിയൽ പരിശോധന",
    yourIdentityLabel: "നിങ്ങൾ",
    identityVerificationHint: "നിങ്ങളുടെ സർക്കാർ-സ്ഥിരീകരിച്ച പേര് വാടക കരാറിൽ കാണിക്കാൻ DigiLocker വഴി നിങ്ങളുടെ തിരിച്ചറിയൽ പരിശോധിക്കുക.",
    confirmLabel: "മുകളിൽ നൽകിയ എന്റെ മൂവ്-ഇൻ വിവരങ്ങൾ ഞാൻ പരിശോധിച്ചു, അവ ശരിയാണെന്ന് സ്ഥിരീകരിക്കുന്നു.",
    submitBtn: "സെറ്റപ്പ് പൂർത്തിയാക്കുക",
    errNameRequired: "നിങ്ങളുടെ പേര് നൽകുക",
    errMustConfirm: "ദയവായി നിങ്ങൾ വിവരങ്ങൾ പരിശോധിച്ചു എന്ന് സ്ഥിരീകരിക്കുക",
    completedToast: "മൂവ്-ഇൻ വിവരങ്ങൾ സ്ഥിരീകരിച്ചു",
  },
  moveInDetails: {
    title: "മൂവ്-ഇൻ വിവരങ്ങൾ",
  },
  locationCapture: {
    pinLocationLabel: "ഈ പ്രോപ്പർട്ടിയുടെ ലൊക്കേഷൻ പിൻ ചെയ്യുക",
    panMapHint: "📌 ശരിയായ സ്ഥലത്ത് പിൻ വയ്ക്കാൻ മാപ്പ് നീക്കുക",
    expandMapAria: "മാപ്പ് വലുതാക്കുക",
    clear: "ക്ലിയർ ചെയ്യുക",
    searchPlaceholder: "ഒരു അഡ്രസ് തിരയുക",
    loadingSearch: "സേർച്ച് ലോഡ് ചെയ്യുന്നു…",
    or: "അല്ലെങ്കിൽ",
    locating: "ലൊക്കേഷൻ കണ്ടെത്തുന്നു…",
    useCurrentLocation: "📍 ഇപ്പോഴത്തെ ലൊക്കേഷൻ ഉപയോഗിക്കുക",
    pickSuggestion: "ഡ്രോപ്ഡൗണിൽ നിന്ന് ഒരു നിർദ്ദേശം തിരഞ്ഞെടുക്കുക",
    locationNotSupported: "ഈ ബ്രൗസറിൽ ലൊക്കേഷൻ സപ്പോർട്ട് ചെയ്യുന്നില്ല",
    locationPermissionDenied: "ലൊക്കേഷൻ അനുമതി നിഷേധിച്ചു",
    locationCouldNotGet: "നിങ്ങളുടെ ലൊക്കേഷൻ കണ്ടെത്താനായില്ല",
    hint: "ഒരു അഡ്രസ് തിരയുക അല്ലെങ്കിൽ താഴെയുള്ള ലൊക്കാലിറ്റി ഓട്ടോ-ഫിൽ ചെയ്യാൻ GPS ടാപ്പ് ചെയ്യുക — ഡോർ നമ്പറും ബിൽഡിംഗിന്റെ പേരും നിങ്ങൾ തന്നെ നൽകേണ്ടിവരും.",
  },
  googleMap: {
    yourLocation: "നിങ്ങളുടെ ലൊക്കേഷൻ",
    couldNotLoad: "Google Maps ലോഡ് ചെയ്യാനായില്ല — API കീ പരിശോധിക്കുക",
    viewDetails: "വിവരങ്ങൾ കാണുക ›",
  },
  rentReceipt: {
    back: "‹ തിരികെ",
    paymentRecordedBanner: "✓ പേയ്‌മെന്റ് രേഖപ്പെടുത്തി — ഇതാ നിങ്ങളുടെ രസീത്.",
    title: "വാടക രസീത്",
    amountPaid: "അടച്ച തുക",
    receiptNoLabel: "രസീത് നമ്പർ",
    paidByLabel: "അടച്ചത്",
    propertyLabel: "പ്രോപ്പർട്ടി",
    receivedByLabel: "സ്വീകരിച്ചത്",
    forMonthLabel: "ഏത് മാസത്തേക്ക്",
    paymentModeLabel: "പേയ്‌മെന്റ് രീതി",
    paidOnLabel: "അടച്ച തീയതി",
    downloadBtn: "ഡൗൺലോഡ് ചെയ്യുക",
    shareBtn: "ഷെയർ ചെയ്യുക",
    htmlTitle: "വാടക രസീത് - {month}",
    htmlStamp: "✓ അടച്ചു",
    htmlAmountPaidLabel: "അടച്ച തുക",
    htmlFooter: "ഇത് ToLetBook-ൽ നിന്നുള്ള ഒരു സിസ്റ്റം-ജനറേറ്റഡ് രസീത് ആണ്. ഇവിടെ കാണിച്ചിരിക്കുന്ന വാടക ആപ്പിനുള്ളിൽ രേഖപ്പെടുത്തിയതാണ്, ഒരു യഥാർത്ഥ പേയ്‌മെന്റ് ഗേറ്റ്‌വേ വഴി പ്രോസസ്സ് ചെയ്തതല്ല.",
    shareTitle: "വാടക രസീത് - {month}",
    shareText: "രസീത് {receiptNo}, തുക {amount}",
  },
  rentalAgreement: {
    back: "‹ തിരികെ",
    title: "റെന്റൽ എഗ്രിമെന്റ്",
    ownerLabel: "ഓണർ",
    tenantLabel: "ടെനന്റ്",
    propertyLabel: "പ്രോപ്പർട്ടി",
    typeLabel: "തരം",
    monthlyRentLabel: "മാസ വാടക",
    securityDepositLabel: "സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ്",
    moveInDateLabel: "മൂവ്-ഇൻ തീയതി",
    disclaimer: "ഇത് രേഖയിലുള്ള ടെനൻസി വിവരങ്ങളിൽ നിന്ന് ഓട്ടോമാറ്റിക്കായി ഉണ്ടാക്കിയ സംഗ്രഹമാണ്, നിയമപരമായി ബാധ്യതയുള്ള ഡോക്യുമെന്റ് അല്ല. സ്റ്റാൻഡേർഡ് ഡെമോ നിബന്ധനകൾ: വാടക എല്ലാ മാസവും 5-ാം തീയതിക്ക് മുമ്പ് അടയ്ക്കണം, ടെനൻസി അവസാനിപ്പിക്കാൻ 30 ദിവസത്തെ നോട്ടീസ്, സാധാരണ തേയ്മാനത്തിന് അപ്പുറമുള്ള നാശനഷ്ടങ്ങൾ കിഴിച്ച് ഡെപ്പോസിറ്റ് തിരികെ കിട്ടും.",
    downloadAgreementBtn: "എഗ്രിമെന്റ് ഡൗൺലോഡ് ചെയ്യുക",
    stampStatusLabel: "E-Stamp സ്റ്റാറ്റസ്",
    stampStatusNotStarted: "തുടങ്ങിയിട്ടില്ല",
    stampStatusProcessing: "പ്രോസസ്സ് ചെയ്യുന്നു",
    stampStatusVerified: "വെരിഫൈ ചെയ്തു",
    stampHint: "ഈ എഗ്രിമെന്റ് സർക്കാരിൽ നിന്ന് നിയമപരമായി E-Stamp ചെയ്യിക്കുക. ഇതിന് {amount} യഥാർത്ഥ സർക്കാർ ഫീസ് ബാധകമാണ്.",
    stampFeeAlreadyPaidHint: "നിങ്ങളുടെ E-Stamp ഫീസ് അടച്ചിട്ടുണ്ട് — ഓർഡർ മാത്രം ഇതുവരെ നൽകാൻ കഴിഞ്ഞില്ല. അധിക ചാർജ് കൂടാതെ താഴെ വീണ്ടും ശ്രമിക്കുക.",
    sendForStampBtn: "{amount} അടച്ച് E-Stamp ന് അയയ്ക്കുക",
    retrySendForStampBtn: "E-Stamp ന് വീണ്ടും അയയ്ക്കുക",
    sendingStampBtn: "അയയ്ക്കുന്നു…",
    confirmingPaymentBtn: "പേയ്‌മെന്റ് സ്ഥിരീകരിക്കുന്നു…",
    stampFeePaymentDesc: "സർക്കാർ E-Stamp ഫീസ്",
    stampFeeFailedToast: "പേയ്‌മെന്റ് പരാജയപ്പെട്ടു — വീണ്ടും ശ്രമിക്കുക",
    stampSentToast: "സർക്കാർ E-Stamping ന് അയച്ചു",
    refreshStatusBtn: "സ്റ്റാറ്റസ് റിഫ്രഷ് ചെയ്യുക",
    viewStampedBtn: "സ്റ്റാമ്പ് ചെയ്ത എഗ്രിമെന്റ് കാണുക",
    identityVerificationLabel: "ഐഡന്റിറ്റി വെരിഫിക്കേഷൻ",
    digilockerVerifiedBadge: "വെരിഫൈ ചെയ്തു",
    digilockerNotVerifiedBadge: "വെരിഫൈ ചെയ്തിട്ടില്ല",
    verifyDigilockerBtn: "DigiLocker ഉപയോഗിച്ച് വെരിഫൈ ചെയ്യുക",
    verifyingDigilockerBtn: "DigiLocker തുറക്കുന്നു…",
    digilockerVerifiedToast: "{name} ആയി വെരിഫൈ ചെയ്തു",
    digilockerDeniedToast: "DigiLocker വെരിഫിക്കേഷൻ റദ്ദാക്കി",
    digilockerExpiredToast: "ആ DigiLocker ലിങ്ക് കാലഹരണപ്പെട്ടു — വീണ്ടും ശ്രമിക്കുക",
    comingSoonTitle: "സർക്കാർ ഇ-സ്റ്റാമ്പിംഗ് ഉടൻ വരുന്നു",
    comingSoonBody: "ആപ്പിൽ നിന്ന് തന്നെ പൂർണ്ണമായും സർക്കാർ-സ്ഥിരീകരിച്ച, ഇ-സ്റ്റാമ്പ്ഡ് വാടക കരാർ ഉണ്ടാക്കാൻ കഴിയുന്ന വിധം ഞങ്ങൾ സ്റ്റാമ്പ് ഡ്യൂട്ടി പേയ്‌മെന്റുകൾ സജ്ജീകരിക്കുകയാണ്.",
    interestBtn: "എനിക്ക് താൽപ്പര്യമുണ്ട് — അറിയിക്കുക",
    interestRegisteredBtn: "നിങ്ങൾ ലിസ്റ്റിലുണ്ട് ✓",
    interestToast: "നന്ദി! ഇ-സ്റ്റാമ്പിംഗ് ലൈവ് ആകുമ്പോൾ ഞങ്ങൾ നിങ്ങളെ അറിയിക്കും.",
    uploadDocHeading: "ഇതിനകം വാടക കരാർ ഉണ്ടോ?",
    uploadDocHint: "നിങ്ങൾ ToLetBook ന് പുറത്ത് ഇതിനകം ഒന്ന് ഉണ്ടാക്കിയിട്ടുണ്ടെങ്കിൽ, ഈ ടെനൻസിക്കൊപ്പം സേവ് ചെയ്യാൻ ഇവിടെ അപ്‌ലോഡ് ചെയ്യുക.",
    uploadDocBtn: "വാടക കരാർ അപ്‌ലോഡ് ചെയ്യുക",
    viewUploadedDocBtn: "അപ്‌ലോഡ് ചെയ്ത കരാർ കാണുക",
    removeUploadedDocBtn: "നീക്കം ചെയ്യുക",
    uploadedOnLabel: "{date} ന് അപ്‌ലോഡ് ചെയ്തു",
    noUploadedDocTenantHint: "നിങ്ങളുടെ ഉടമ ഇതുവരെ വാടക കരാർ അപ്‌ലോഡ് ചെയ്തിട്ടില്ല.",
    uploadDocSuccessToast: "വാടക കരാർ അപ്‌ലോഡ് ചെയ്തു",
    uploadDocFailedToast: "അപ്‌ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല — 8MB ൽ താഴെയുള്ള PDF അല്ലെങ്കിൽ ചിത്രം ശ്രമിക്കുക",
    removeDocConfirm: "അപ്‌ലോഡ് ചെയ്ത വാടക കരാർ നീക്കം ചെയ്യണോ?",
    removeDocSuccessToast: "വാടക കരാർ നീക്കം ചെയ്തു",
    htmlTitle: "റെന്റൽ എഗ്രിമെന്റ് - {property}",
    htmlDocTitle: "റെന്റൽ എഗ്രിമെന്റ് സംഗ്രഹം",
    htmlAgreementNo: "എഗ്രിമെന്റ് നമ്പർ {no}",
    htmlOwnerLessor: "ഓണർ / ലെസർ",
    htmlTenantLessee: "ടെനന്റ് / ലെസി",
    htmlPropertyHeading: "പ്രോപ്പർട്ടി",
    htmlAddressLabel: "അഡ്രസ്",
    htmlTypeLabel: "തരം",
    htmlTermsHeading: "നിബന്ധനകൾ",
    htmlMonthlyRentLabel: "മാസ വാടക",
    htmlSecurityDepositLabel: "സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ്",
    htmlMoveInDateLabel: "മൂവ്-ഇൻ തീയതി",
    htmlConditionsHeading: "വ്യവസ്ഥകൾ",
    htmlCond1: "എല്ലാ മാസവും 5-ാം തീയതിക്ക് മുമ്പോ അന്നോ, സമ്മതിച്ച രീതിയിൽ ഓണർക്ക് വാടക അടയ്ക്കണം.",
    htmlCond2: "സാധാരണ തേയ്മാനത്തിന് അപ്പുറമുള്ള നാശനഷ്ടങ്ങൾക്കുള്ള കിഴിവുകൾ കുറച്ച്, മാറിപ്പോകുമ്പോൾ സെക്യൂരിറ്റി ഡെപ്പോസിറ്റ് തിരികെ നൽകും.",
    htmlCond3: "ടെനൻസി അവസാനിപ്പിക്കുന്നതിന് മുമ്പ് ഇരു കക്ഷികളും കുറഞ്ഞത് 30 ദിവസത്തെ രേഖാമൂലമുള്ള നോട്ടീസ് നൽകണം.",
    htmlCond4: "ഓണറുമായി വേറെ എന്തെങ്കിലും ധാരണയില്ലെങ്കിൽ, യൂട്ടിലിറ്റി ബില്ലുകളുടെ ഉത്തരവാദിത്തം ടെനന്റിനാണ്.",
    htmlCond5: "ടെനന്റിന്റെ അശ്രദ്ധ മൂലം നാശനഷ്ടം സംഭവിച്ചതല്ലെങ്കിൽ, ഫിക്സ്ചറുകളുടെയും ഫിറ്റിംഗുകളുടെയും മെയിന്റനൻസ് ഓണറുടെ ഉത്തരവാദിത്തമാണ്.",
    htmlFooter: "ഈ സംഗ്രഹം ToLetBook രേഖയിലുള്ള ടെനൻസി വിവരങ്ങളിൽ നിന്ന് ഓട്ടോമാറ്റിക്കായി ഉണ്ടാക്കിയതാണ്, ഇത് നിയമപരമായി ബാധ്യതയുള്ള ഡോക്യുമെന്റ് അല്ല. ഔപചാരികമായ റെന്റൽ എഗ്രിമെന്റ് തയ്യാറാക്കാൻ ഒരു നിയമ വിദഗ്ധനെ സമീപിക്കുക.",
  },
  photoLightbox: {
    closeAria: "അടയ്ക്കുക",
    previousPhotoAria: "മുമ്പത്തെ ഫോട്ടോ",
    nextPhotoAria: "അടുത്ത ഫോട്ടോ",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "പ്ലാൻ",
    currentPlanLabel: "നിലവിലെ പ്ലാൻ",
    basicName: "ബേസിക്",
    proName: "ടെനന്റ് പ്രോ",
    proSub: "സജീവമായി വീട് അന്വേഷിക്കുന്ന ടെനന്റുകൾക്ക്",
    priceValidity: "1 മാസത്തേക്ക് സാധുവാണ്",
    featUnlock: "30 ദിവസത്തേക്ക് അൺലിമിറ്റഡ് ഓണർ കോൺടാക്റ്റ് നമ്പറുകൾ അൺലോക്ക് ചെയ്യൂ",
    featNearby: "എല്ലാ ലിസ്റ്റിംഗിലും പൂർണ്ണ മാപ്പും സമീപ-സ്ഥലങ്ങളിലേക്കുള്ള ആക്സസും",
    featWhatsapp: "ഓണറുമായി നേരിട്ട് WhatsApp-ൽ സംസാരിക്കൂ, ഓരോ ലിസ്റ്റിംഗിനും ഫീസ് ഇല്ല",
    featFallback: "സബ്‌സ്ക്രൈബ് ചെയ്യുന്നില്ലെങ്കിലും 1 ഓണറുടെ കോൺടാക്റ്റ് സൗജന്യമായി അൺലോക്ക് ചെയ്യാം — അതിനുശേഷം അപ്‌ഗ്രേഡ് ചെയ്യണം",
    currentPlanBtn: "നിലവിലെ പ്ലാൻ",
    subscribeBtn: "₹99ന് സബ്‌സ്ക്രൈബ് ചെയ്യൂ",
    activeUntil: "{date} വരെ ആക്ടീവ്",
    noChargeNote: "ഇതുവരെ പേയ്‌മെന്റ് ആവശ്യമില്ല — ബില്ലിംഗ് സെറ്റപ്പ് ചെയ്യുന്നത് വരെ സബ്‌സ്ക്രൈബ് ചെയ്യുന്നത് സൗജന്യമാണ്.",
    subscribedToast: "ടെനന്റ് പ്രോ ആക്ടിവേറ്റ് ചെയ്തു",
    switchFailedToast: "നിങ്ങളുടെ പ്ലാൻ അപ്‌ഡേറ്റ് ചെയ്യാൻ കഴിഞ്ഞില്ല",
    nearbyUpsellTitle: "മാപ്പും സമീപ സ്ഥലങ്ങളും അൺലോക്ക് ചെയ്യൂ",
    nearbyUpsellBody: "എല്ലാ ലിസ്റ്റിംഗിനും സമീപമുള്ള ട്രാൻസിറ്റ്, അവശ്യവസ്തുക്കൾ, ആരോഗ്യസംരക്ഷണം എന്നിവ കാണാൻ ടെനന്റ് പ്രോയ്ക്ക് സബ്‌സ്ക്രൈബ് ചെയ്യൂ.",
    nearbyUpsellBtn: "ടെനന്റ് പ്രോ കാണൂ",
    cancelPlanBtn: "പ്ലാൻ റദ്ദാക്കുക",
    securePaymentNote: "പേയ്‌മെന്റുകൾ Razorpay വഴി സുരക്ഷിതമായി പ്രോസസ്സ് ചെയ്യുന്നു.",
    cancelledToast: "ടെനന്റ് പ്രോ റദ്ദാക്കി",
  },
};
